import { useState, useEffect, useCallback, useRef } from 'react';
import { useParams, useNavigate, useLocation, Link } from 'react-router-dom';
import KanalZeitstrahl from '@/components/KanalZeitstrahl';
import EinschaetzungPanel from '@/components/EinschaetzungPanel';
import EmailSendenDialog from '@/components/EmailSendenDialog';
import KurzFeedback from '@/components/KurzFeedback';
import OnboardingPanel from '@/components/OnboardingPanel';
import DatenabgleichPanel from '@/components/DatenabgleichPanel';
import GuertelKarte from '@/components/GuertelKarte';
import CheckupKarte from '@/components/CheckupKarte';
import TurniererfolgKarte from '@/components/TurniererfolgKarte';
import CheckupErgebnisKarte from '@/components/CheckupErgebnisKarte';
import CoachingKarte from '@/components/CoachingKarte';
import ProbeplanKarte from '@/components/ProbeplanKarte';
import UpsellPanel from '@/components/UpsellPanel';
import AdresseKarte from '@/components/adressen/AdresseKarte';
import TeilnahmeKachel from '@/components/teilnahme/TeilnahmeKachel';
import AkteKopf from '@/components/kundenakte/AkteKopf';
import AkteUebersicht from '@/components/kundenakte/AkteUebersicht';
import AngebotErstellen from '@/components/kundenakte/AngebotErstellen';
import { CheckupStepperPanel } from '@/components/CheckupStepper';
import KundeEntwicklung from '@/components/KundeEntwicklung';
import KundeFortschritt from '@/components/KundeFortschritt';
import Ernaehrungsprotokoll from '@/components/Ernaehrungsprotokoll';
import { leadsAPI, activitiesAPI, followUpsAPI, aiAPI, integrationsAPI, authAPI, trainingAPI, dsgvoAPI, familyAPI, stammplatzAPI, superchatAPI, teilnehmerlisteAPI } from '@/lib/api';
import { validateName, validatePhone } from '@/lib/validation';
import { toTitleCase, initial, alsText, schrittText } from '@/lib/text';
import { challengeAPI } from '@/lib/api';
import api from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';
import { getActivityIcon } from '@/lib/activity-types';
import {
  ArrowLeft, Phone, Mail, Calendar, Building2, Clock, Plus, Edit2, Save, X, MessageSquare, Eye, FileText, Brain, Sparkles, Loader2, Send, ChevronLeft, ChevronRight, Dumbbell, Trash2, Archive, CalendarCheck, CalendarSync, Smartphone
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Textarea } from '@/components/ui/textarea';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter
} from '@/components/ui/dialog';
import StufenwechselDialog from '@/components/StufenwechselDialog';
import DokumenteTab from '@/components/DokumenteTab';
import ProbetrainingDialog from '@/components/ProbetrainingDialog';
import ProbetrainingErgebnis from '@/components/ProbetrainingErgebnis';
import ProbetrainingVerschieben from '@/components/ProbetrainingVerschieben';
import SmsDialog from '@/components/SmsDialog';
import TrainingslogTab from '@/components/TrainingslogTab';
import { GewohnheitenCrm } from '@/components/Gewohnheiten';
import { CoachChatCrm } from '@/components/CoachChat';
import { FortschrittsfotosCrm } from '@/components/Fortschrittsfotos';
import { LeistungstestsCrm } from '@/components/Leistungstests';
import { TechnikVideosCrm } from '@/components/TechnikVideos';
import KraftlogPtZugang from '@/components/KraftlogPtZugang';
import CheckinNachtragen from '@/components/CheckinNachtragen';
import KurskontingentZeile from '@/components/KurskontingentZeile';
import MitgliedRechnungen from '@/components/MitgliedRechnungen';
import FinanzKarte from '@/components/FinanzKarte';
import { toast } from 'sonner';
import { useSettings } from '@/contexts/SettingsContext';

export default function LeadDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [lead, setLead] = useState(null);
  const [ptStand, setPtStand] = useState(0);   // zählt hoch, wenn die Karte „PT-Zugang“ etwas geschaltet hat
  const [checkupStand, setCheckupStand] = useState(0);   // zählt hoch, wenn die Karte „Check-Up“ etwas eingetragen oder geändert hat
  const [activities, setActivities] = useState([]);
  const [followUps, setFollowUps] = useState([]);
  const [editing, setEditing] = useState(false);
  const [editForm, setEditForm] = useState({});
  const [showAddActivity, setShowAddActivity] = useState(false);
  const [showAddFollowUp, setShowAddFollowUp] = useState(false);
  const [showAddTraining, setShowAddTraining] = useState(false);
  const [trainingHistory, setTrainingHistory] = useState([]);
  const [trainingStats, setTrainingStats] = useState(null);
  const [scoring, setScoring] = useState(false);
  const [ptOffen, setPtOffen] = useState(false);
  // Termin verschieben (06.10.2026): die Buchungs-ID vom Klick. Nicht lead.probetraining.buchung_id durchreichen,
  // die wechselt mit der Umbuchung, und der Dialog verlöre seine Rückmeldung.
  const [ptVerschieben, setPtVerschieben] = useState(null);
  // Der Zeitstrahl lädt selbst: Nach dem Verschieben neu laden lassen, sonst fehlt die Notiz bis zum Neuladen der Seite
  const [zeitstrahlStand, setZeitstrahlStand] = useState(0);
  // SMS über das Geschäftshandy (06.10.2026): öffnet die Nachrichten-App, das CRM verschickt nichts selbst
  const [smsOffen, setSmsOffen] = useState(false);
  const [showSendMessage, setShowSendMessage] = useState(null);
  const [showEmail, setShowEmail] = useState(false);
  const [editErrors, setEditErrors] = useState({});
  const [agents, setAgents] = useState([]);
  const { settings, stageMap, formatCurrency, formatDate, formatDateTime } = useSettings();
  // App-Rolle darf nur setzen, wer auch CRM-Rollen vergeben darf — sie oeffnet
  // in der App fremde Mitgliederdaten und die Studiotuer.
  const { user, userPermissions, isAdminPermissions } = useAuth();
  // userPermissions ist ein Objekt {recht: true} (siehe /auth/my-permissions),
  // keine Liste — `.includes` darauf hat jedem Nicht-Admin die Detailseite
  // abgeschossen (Admins kamen nur durch das Kurzschliessen davor vorbei).
  const darfAppRolle = isAdminPermissions || !!(userPermissions || {})['team.change_roles'];
  // Rechnungen je Mitglied (15.10.2026): Finanzdaten — nur mit finanzen.view (wie Finanzen › Rechnungen)
  const darfRechnungen = isAdminPermissions || !!(userPermissions || {})['finanzen.view'];
  const [appRolleLaeuft, setAppRolleLaeuft] = useState(false);
  // Kundenakte (28.10.2026): Kopf + Startansicht „Übersicht“ aus EINEM Aufruf (GET /api/kunden/{id}/akte)
  const darfErnaehrung = isAdminPermissions || !!(userPermissions || {})['ernaehrung.view'];
  // Fortschritt-Tab (W2.4, 29.10.2026): Training und Heatmap auch mit training.view; Messwerte liefert der Server nur mit ernaehrung.view
  const darfFortschritt = darfErnaehrung || !!(userPermissions || {})['training.view'];
  const [fortschrittAnsicht, setFortschrittAnsicht] = useState('fortschritt');
  const [akte, setAkte] = useState(null);
  const [akteFehler, setAkteFehler] = useState(null);
  const [reiter, setReiter] = useState(() => new URLSearchParams(location.search).get('tab') || 'uebersicht');
  // Check-up-Stepper als Panel (Schritt 3/4): aus „Check-up starten“ oder dem Link der Aufgabe „Check-up abschließen“ (?checkup=)
  const [stepperCheckup, setStepperCheckup] = useState(() => new URLSearchParams(location.search).get('checkup'));
  const [angebotOffen, setAngebotOffen] = useState(false);
  const darfLeadBearbeiten = isAdminPermissions || !!(userPermissions || {})['leads.edit'];
  const ladeAkte = useCallback(async () => {
    try {
      const r = await api.get(`/kunden/${id}/akte`);
      setAkte(r.data); setAkteFehler(null);
    } catch (err) {
      setAkte(null); setAkteFehler(err.response?.data?.detail || 'Fehler beim Laden');
    }
  }, [id]);
  useEffect(() => { setAkte(null); ladeAkte(); }, [ladeAkte, checkupStand, ptStand]);
  const zuKarte = (anker) => document.getElementById(anker)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  const whatsappOeffnen = async () => {
    try { const r = await superchatAPI.konversationFuerLead(id, 'whatsapp'); navigate(`/posteingang?konv=${r.data.konversation_id}`); }
    catch (err) { toast.error(err.response?.data?.detail || 'WhatsApp-Verlauf konnte nicht geöffnet werden'); }
  };
  const checkupStarten = () => {
    const cid = akte?.checkup_start?.checkup_id;
    if (cid && darfLeadBearbeiten) setStepperCheckup(cid);
    else zuKarte('akte-checkup-karte');
  };
  const akteAktion = (aktion) => {
    if (aktion === 'checkup') checkupStarten();
    else if (aktion === 'coaching' || aktion === 'checkin') zuKarte('akte-coaching-karte');     // Check-ins hängen an der Karte P1 Coaching
    else if (aktion === 'chat') whatsappOeffnen();
    else if (aktion === 'angebot') {
      if (akte?.angebote_offen?.length) zuKarte('akte-angebote');
      else if (darfLeadBearbeiten) setAngebotOffen(true);
    }
  };
  
  // Get sources list
  const SOURCES = settings.lead_sources || [];
  
  // Title case helper
  
  // Get back path from location state or default to pipeline
  const backPath = location.state?.from || '/pipeline';
  
  // Get lead IDs array for prev/next navigation
  const leadIds = location.state?.leadIds || [];
  const currentIndex = leadIds.indexOf(id);
  const hasPrev = currentIndex > 0;
  const hasNext = currentIndex >= 0 && currentIndex < leadIds.length - 1;
  const prevLeadId = hasPrev ? leadIds[currentIndex - 1] : null;
  const nextLeadId = hasNext ? leadIds[currentIndex + 1] : null;
  
  const navigateToLead = (targetId) => {
    navigate(`/leads/${targetId}`, { 
      state: { 
        from: backPath,
        leadIds: leadIds 
      } 
    });
  };

  const fetchLead = useCallback(async () => {
    try {
      const res = await leadsAPI.get(id);
      setLead(res.data);
      setEditForm(res.data);
    } catch { navigate(backPath); }
  }, [id, navigate, backPath]);

  const fetchActivities = useCallback(async () => {
    const res = await activitiesAPI.list({ lead_id: id, limit: 50 });
    setActivities(res.data.activities);
  }, [id]);

  const fetchFollowUps = useCallback(async () => {
    const res = await followUpsAPI.list({ lead_id: id });
    setFollowUps(res.data.follow_ups);
  }, [id]);

  const fetchAgents = useCallback(async () => {
    try {
      const res = await authAPI.users();
      setAgents(res.data || []);
    } catch (err) {
      
    }
  }, []);

  const fetchTraining = useCallback(async () => {
    try {
      const res = await trainingAPI.getMemberHistory(id);
      setTrainingHistory(res.data.history || []);
      setTrainingStats(res.data.stats || null);
    } catch (err) {
      
    }
  }, [id]);

  useEffect(() => {
    fetchLead();
    fetchActivities();
    fetchFollowUps();
    fetchAgents();
    fetchTraining();
  }, [fetchLead, fetchActivities, fetchFollowUps, fetchAgents, fetchTraining]);

  const handleSave = async () => {
    const errs = {};
    const nameErr = validateName(editForm.name, 'Name', { min: 2, max: 100 });
    if (nameErr) errs.name = nameErr;
    if (editForm.email && !/^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(editForm.email.trim())) errs.email = 'Invalid email format';
    const phoneErr = validatePhone(editForm.phone);
    if (phoneErr) errs.phone = phoneErr;
    if (editForm.budget_min != null && editForm.budget_min < 0) errs.budget_min = 'Must be positive';
    if (editForm.budget_max != null && editForm.budget_max < 0) errs.budget_max = 'Must be positive';
    if (editForm.budget_min != null && editForm.budget_max != null && editForm.budget_max < editForm.budget_min) errs.budget_max = 'Must be >= min';

    setEditErrors(errs);
    if (Object.keys(errs).length > 0) {
      toast.error(Object.values(errs)[0]);
      return;
    }

    try {
      await leadsAPI.update(id, {
        ...editForm,
        name: editForm.name?.trim(),
        email: editForm.email?.trim().toLowerCase() || null,
        phone: editForm.phone?.trim() || null,
      });
      // Die App-Rolle geht ihren eigenen, protokollierten Weg — das normale
      // Lead-Update nimmt sie serverseitig nicht mehr an.
      const rolleNeu = editForm.app_role || '';
      if (darfAppRolle && rolleNeu !== (lead.app_role || '')) {
        await leadsAPI.appRolle(id, rolleNeu);
      }
      // Headcoach-Kennzeichen (Trainingsplaner A0): eigener, protokollierter Weg wie die App-Rolle
      const headcoachNeu = !!editForm.app_headcoach && (rolleNeu === 'trainer' || rolleNeu === 'admin');
      if (darfAppRolle && headcoachNeu !== !!lead.app_headcoach) {
        await leadsAPI.headcoach(id, headcoachNeu);
      }
      toast.success('Mitglied aktualisiert');
      setEditing(false);
      setEditErrors({});
      fetchLead();
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(Array.isArray(detail) ? detail[0]?.msg : (typeof detail === 'string' ? detail : 'Update failed'));
    }
  };

  // Stufenwechsel mit Regel R2: braucht das Backend einen naechsten Schritt
  // (422) oder ist die Zielstufe „verloren", fragt ein Dialog nach — statt
  // nur „Fehlgeschlagen" zu zeigen (22.09.2026).
  const [stufenDialog, setStufenDialog] = useState(null); // { stage, hinweis }
  const stufeLabelVon = (key) => (settings?.pipeline_stages || []).find((s) => s.key === key)?.label || key;
  const stufeSetzen = async (stage, extra = {}) => {
    await leadsAPI.updateStage(id, stage, extra);
    toast.success(`Phase: ${stufeLabelVon(stage)}`);
    setStufenDialog(null);
    fetchLead();
  };
  const handleStageChange = async (stage) => {
    if (stage === 'verloren') { setStufenDialog({ stage }); return; }
    // Kunde wird ein Lead nur mit Vertrag (30.10.2026): statt die Stufe zu setzen, öffnet der Verkaufsrechner mit dem Lead.
    // Der Server lehnt den Wechsel ohne Vertrag ebenfalls ab (409).
    if ((stage === 'customer' || stage === 'abschluss') && lead?.stage !== stage) {
      toast.info('Ein Lead wird nur mit Vertrag zum Kunden — der Verkaufsrechner ist offen.');
      navigate(`/verkauf?lead=${encodeURIComponent(id)}`);
      fetchLead();
      return;
    }
    try {
      await stufeSetzen(stage);
    } catch (err) {
      const status = err?.response?.status;
      const detail = err?.response?.data?.detail;
      const text = Array.isArray(detail) ? detail[0]?.msg : (typeof detail === 'string' ? detail : '');
      if (status === 422 && /Schritt|R2/.test(text)) { setStufenDialog({ stage, hinweis: text }); return; }
      toast.error(text || 'Stufenwechsel fehlgeschlagen');
    }
  };
  const stufenDialogBestaetigen = async (extra) => {
    try { await stufeSetzen(stufenDialog.stage, extra); }
    catch (err) { const d = err?.response?.data?.detail; toast.error(typeof d === 'string' ? d : 'Stufenwechsel fehlgeschlagen'); }
  };

  // Der Lead in der Form, die der gemeinsame Baustein für Da / Nicht da / Ergebnis erwartet (wie eine Zeile der Probetrainings-Liste)
  const leadAlsPt = lead ? { id: lead.id, name: lead.name, phone: lead.phone, email: lead.email, termin_status: lead.termin_status,
    probetraining: { ...(lead.probetraining || {}), ergebnis: lead.probetraining?.ergebnis || lead.probetraining_ergebnis?.ergebnis,
      am_lead: !lead.probetraining?.buchung_id, status: lead.probetraining?.status || (lead.termin_status === 'besucht' ? 'erschienen' : undefined) } } : null;

  if (!lead) return <div className="flex items-center justify-center h-64"><div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div className="space-y-6 fade-in" data-testid="lead-detail-page">
      {stepperCheckup && (
        <CheckupStepperPanel leadId={id} checkupId={stepperCheckup}
          onClose={() => {
            setStepperCheckup(null); setCheckupStand((n) => n + 1);
            if (new URLSearchParams(location.search).get('checkup')) navigate(location.pathname, { replace: true, state: location.state });
          }} />
      )}
      <AngebotErstellen leadId={id} offen={angebotOffen} onClose={() => setAngebotOffen(false)} onGesendet={ladeAkte} />
      <StufenwechselDialog offen={!!stufenDialog} stufeLabel={stufenDialog ? stufeLabelVon(stufenDialog.stage) : ''} verloren={stufenDialog?.stage === 'verloren'} hinweis={stufenDialog?.hinweis} onBestaetigen={stufenDialogBestaetigen} onAbbrechen={() => { setStufenDialog(null); fetchLead(); }} />
      {/* Header with Navigation */}
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" onClick={() => navigate(backPath)} data-testid="back-btn">
            <ArrowLeft className="w-4 h-4 mr-1" /> Zurück
          </Button>
          
          {/* Prev/Next Navigation */}
          {leadIds.length > 0 && (
            <div className="flex items-center gap-1 ml-2 border-l pl-2">
              <Button 
                variant="outline" 
                size="sm" 
                onClick={() => navigateToLead(prevLeadId)}
                disabled={!hasPrev}
                className="h-8 w-8 p-0"
                title="Previous lead"
              >
                <ChevronLeft className="w-4 h-4" />
              </Button>
              <span className="text-xs text-muted-foreground px-2">
                {currentIndex + 1} / {leadIds.length}
              </span>
              <Button 
                variant="outline" 
                size="sm" 
                onClick={() => navigateToLead(nextLeadId)}
                disabled={!hasNext}
                className="h-8 w-8 p-0"
                title="Next lead"
              >
                <ChevronRight className="w-4 h-4" />
              </Button>
            </div>
          )}
        </div>
      </div>

      {lead.archiviert && (
        <div className="rounded-md border border-amber-300 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/30 px-3 py-2 text-sm flex items-center gap-2" data-testid="archiv-banner">
          <Archive className="w-4 h-4 flex-shrink-0" />
          <span>
            Dieser Lead ist archiviert und taucht in Listen, Pipeline und
            Kennzahlen nicht auf. Ein Stage-Wechsel oder eine neue Buchung
            holt ihn automatisch zurück.
          </span>
        </div>
      )}

      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3">
        {/* Kopf der Kundenakte (28.10.2026): Name, Alter, Mitglied seit, Tarif, Bausteine, Status, Hauptziel, Coach + Aktionen */}
        <AkteKopf lead={lead} akte={akte} stufeText={stufeLabelVon}
          onCheckup={checkupStarten} onNachricht={whatsappOeffnen}
          onAngebot={() => setAngebotOffen(true)} darfAngebot={darfLeadBearbeiten}
          onTermin={() => { if (!akte || akte.kopf?.status?.schluessel === 'lead') setPtOffen(true); else navigate('/kalender'); }} />
        <div className="flex items-center gap-2 flex-wrap">
          <select value={lead.stage || ""} onChange={(e) => handleStageChange(e.target.value)} data-testid="lead-stage-dropdown" className="flex h-9 w-[140px] rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring">
            {(settings.pipeline_stages || []).map((s) => (
              <option key={s.key} value={s.key}>{s.label}</option>
            ))}
          </select>
          {editing ? (
            <>
              <Button size="sm" onClick={handleSave} data-testid="save-lead-edit" className="gap-1">
                <Save className="w-4 h-4" />Speichern
              </Button>
              <Button size="sm" variant="outline" onClick={() => { setEditing(false); setEditForm(lead); setEditErrors({}); }} className="gap-1">
                <X className="w-4 h-4" />Abbrechen
              </Button>
              <span className="text-xs text-muted-foreground hidden sm:inline">Speichern auch unten möglich</span>
            </>
          ) : (
            <>
              <Button size="sm" variant="outline" className="gap-1" onClick={() => setPtOffen(true)} data-testid="lead-probetraining"><CalendarCheck className="w-4 h-4" /> Probetraining</Button>
              {/* Kurz-Feedback nach Beratung/Abschluss (31.10.2026): Notiz, wahlweise Nachfass-Aufgabe; Pia liest es (rueckmeldungen) */}
              {(isAdminPermissions || !!(userPermissions || {})['leads.edit']) && (
                <KurzFeedback leadId={id} name={lead.name} onFertig={() => { fetchLead?.(); setZeitstrahlStand(n => n + 1); }} />
              )}
              {/* Geplantes Probetraining mit Buchung im Termin-Kern: Termin verschieben (06.10.2026) */}
              {lead.termin_status === 'geplant' && lead.probetraining?.buchung_id && (isAdminPermissions || !!(userPermissions || {})['leads.edit']) && (
                <Button size="sm" variant="outline" className="gap-1" onClick={() => setPtVerschieben(lead.probetraining.buchung_id)} data-testid="lead-pt-verschieben"><CalendarSync className="w-4 h-4" /> Termin verschieben</Button>
              )}
              <ProbetrainingVerschieben buchungId={ptVerschieben} onClose={() => setPtVerschieben(null)} onFertig={(daten) => { fetchLead?.(); fetchActivities?.(); if (daten) setZeitstrahlStand(n => n + 1); }} />
              {lead.phone && (isAdminPermissions || !!(userPermissions || {})['leads.edit']) && (
                <Button size="sm" variant="outline" className="gap-1" onClick={() => setSmsOffen(true)} data-testid="lead-sms"><Smartphone className="w-4 h-4" /> SMS</Button>
              )}
              <ProbetrainingDialog offen={ptOffen} onClose={() => setPtOffen(false)} onFertig={() => { fetchLead?.(); }}
                vorbelegt={{ vorname: (lead.name || '').split(' ').slice(0, -1).join(' ') || (lead.name || ''), nachname: (lead.name || '').split(' ').length > 1 ? (lead.name || '').split(' ').slice(-1)[0] : '',
                  telefon: lead.phone || '', email: lead.email || '', zielgruppe: (lead.bereich === 'kinder_jugend' || /kinder|bambini|jugend/.test(lead.altersgruppe || '')) ? 'kind' : 'erwachsen',
                  // Der Lead heißt oft nach dem ELTERNTEIL (Kinder-Funnel, Landingpage, OneClickGym): das Kind bekommt
                  // ein eigenes Feld, sonst stünde in der Bestätigung „Sabines Probetraining“. Vorbelegt nur, wo der
                  // Lead sicher nach dem Kind heißt (selbst erfasst, Kind eines Elternkontos).
                  kind_vorname: ['schnellerfassung', 'funnel:schnellerfassung', 'trainer_schnellerfassung', 'familie'].includes(lead.source || '')
                    && (lead.bereich === 'kinder_jugend' || /kinder|bambini|jugend/.test(lead.altersgruppe || ''))
                    ? ((lead.name || '').split(' ').slice(0, -1).join(' ') || (lead.name || '')) : '' }} />
              <Button
                size="sm"
                variant="outline"
                onClick={async () => {
                  setScoring(true);
                  try {
                    const res = await aiAPI.scoreLead(id);
                    toast.success(`Lead scored: ${res.data.grade} (${res.data.score}/100)`);
                    fetchLead();
                  } catch (err) {
                    toast.error(err.response?.data?.detail || 'Scoring failed');
                  } finally { setScoring(false); }
                }}
                disabled={scoring}
                data-testid="score-lead-btn"
                className="gap-1.5"
              >
                {scoring ? <Loader2 className="w-4 h-4 animate-spin" /> : <Brain className="w-4 h-4" />}
                {scoring ? 'Scoring...' : 'AI Score'}
              </Button>
              <Button size="sm" variant="outline" onClick={() => setEditing(true)} data-testid="edit-lead-btn"><Edit2 className="w-4 h-4 mr-1" />Bearbeiten</Button>
              <Button size="sm" variant="outline" data-testid="archiv-lead-btn" className="gap-1.5"
                onClick={async () => {
                  try {
                    const res = await leadsAPI.archiv(id, !lead.archiviert);
                    toast.success(res.data.archiviert ? 'Lead archiviert' : 'Aus dem Archiv geholt');
                    fetchLead();
                  } catch (err) {
                    toast.error(err.response?.data?.detail || 'Archivieren fehlgeschlagen');
                  }
                }}>
                <Archive className="w-4 h-4" />{lead.archiviert ? 'Aus Archiv holen' : 'Archivieren'}
              </Button>
              {lead.app_role && (
                <Badge variant="outline" className="border-emerald-300 text-emerald-700 gap-1">
                  <Dumbbell className="w-3.5 h-3.5" />
                  App: {lead.app_role === 'admin' ? 'Leitung' : 'Trainer'}
                </Badge>
              )}
              <StammplatzQrButton leadId={id} />
            </>
          )}
        </div>
      </div>

      {/* Main Content */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left - Details */}
        <div className="lg:col-span-1 space-y-4">
          <Card className="border-border/60">
            <CardHeader className="pb-3"><CardTitle className="text-sm">Details</CardTitle></CardHeader>
            <CardContent className="space-y-3 text-sm">
              {editing ? (
                <div className="space-y-3">
                  <div>
                    <Label className="text-xs">Name *</Label>
                    <Input value={editForm.name || ''} onChange={(e) => setEditForm(p => ({...p, name: e.target.value}))} className={editErrors.name ? 'border-destructive' : ''} />
                    {editErrors.name && <p className="text-[10px] text-destructive mt-0.5">{editErrors.name}</p>}
                  </div>
                  <div>
                    <Label className="text-xs">Email</Label>
                    <Input value={editForm.email || ''} onChange={(e) => setEditForm(p => ({...p, email: e.target.value}))} className={editErrors.email ? 'border-destructive' : ''} />
                    {editErrors.email && <p className="text-[10px] text-destructive mt-0.5">{editErrors.email}</p>}
                  </div>
                  <div>
                    <Label className="text-xs">Phone</Label>
                    <Input value={editForm.phone || ''} onChange={(e) => setEditForm(p => ({...p, phone: e.target.value}))} placeholder="+14155551234" className={editErrors.phone ? 'border-destructive' : ''} />
                    {editErrors.phone && <p className="text-[10px] text-destructive mt-0.5">{editErrors.phone}</p>}
                  </div>
                  <div>
                    <Label className="text-xs">Quelle</Label>
                    <select 
                      value={editForm.source || 'laufkundschaft'} 
                      onChange={(e) => setEditForm(p => ({...p, source: e.target.value}))} 
                      className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm"
                    >
                      {SOURCES.map(s => <option key={s} value={s}>{toTitleCase(s)}</option>)}
                    </select>
                  </div>
                  <div>
                    <Label className="text-xs">Bereich</Label>
                    <select value={editForm.bereich || ''} onChange={(e) => setEditForm(p => ({...p, bereich: e.target.value}))} className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm">
                      <option value="">– Auswählen –</option>
                      {(settings.bereiche || []).map(b => <option key={b.key} value={b.key}>{b.label}</option>)}
                    </select>
                  </div>
                  <div>
                    <Label className="text-xs">Altersgruppe</Label>
                    <select value={editForm.altersgruppe || ''} onChange={(e) => setEditForm(p => ({...p, altersgruppe: e.target.value}))} className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm">
                      <option value="">– Auswählen –</option>
                      {(settings.altersgruppen || []).map(a => <option key={a.key} value={a.key}>{a.label}</option>)}
                    </select>
                  </div>
                  <div>
                    <Label className="text-xs">Kampagne</Label>
                    <select value={editForm.kampagne || ''} onChange={(e) => setEditForm(p => ({...p, kampagne: e.target.value}))} className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm">
                      <option value="">Keine</option>
                      {(settings.kampagnen || []).map(k => <option key={k.key} value={k.key}>{k.label}</option>)}
                    </select>
                  </div>
                  <div>
                    <Label className="text-xs">Termin-Status</Label>
                    {/* Kein Dropdown mehr, das ohne Buchung still speichert (30.10.2026): derselbe Baustein wie in der Liste */}
                    <div className="flex items-center gap-2 h-9 text-sm" data-testid="termin-status-baustein">
                      <span className="text-muted-foreground">{lead.termin_status === 'geplant' ? 'Probetraining geplant' : lead.termin_status === 'besucht' ? 'Besucht' : lead.termin_status === 'no_show' ? 'No-Show' : lead.termin_status === 'abgesagt' ? 'Abgesagt' : 'Kein Termin'}</span>
                      {lead.termin_status === 'geplant' && (isAdminPermissions || !!(userPermissions || {})['leads.edit']) && (
                        <ProbetrainingErgebnis pt={leadAlsPt} onFertig={() => fetchLead?.()} navigate={navigate} nurFaellige={false} />
                      )}
                    </div>
                  </div>
                  <div>
                    <Label className="text-xs">Nächster Schritt</Label>
                    <Input value={schrittText(editForm.naechster_schritt)} onChange={(e) => setEditForm(p => ({...p, naechster_schritt: e.target.value}))} placeholder="z.B. Angebot senden, Probetraining planen" />
                  </div>
                  <div>
                    <Label className="text-xs">Priorität</Label>
                    <select value={editForm.priority || 'mittel'} onChange={(e) => setEditForm(p => ({...p, priority: e.target.value}))} className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm">
                      <option value="niedrig">Niedrig</option>
                      <option value="mittel">Mittel</option>
                      <option value="hoch">Hoch</option>
                      <option value="dringend">Dringend</option>
                    </select>
                  </div>
                  <div>
                    <Label className="text-xs">Gürtel</Label>
                    <select value={editForm.belt || ''} onChange={(e) => setEditForm(p => ({...p, belt: e.target.value}))} className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm">
                      <option value="">Kein Gürtel</option>
                      {(settings.belt_progression || []).map(b => <option key={b.key} value={b.key}>{b.label}</option>)}
                    </select>
                  </div>

                  {/* App-Rolle — steuert Trainer-Bereich, Klassenlisten mit Notfallkontakten
                      und Türöffnung ohne Check-in. Läuft NICHT über das normale
                      Lead-Formular (leads.edit hat jeder Trainer), sondern über den
                      eigenen, protokollierten Weg mit team.change_roles. */}
                  {darfAppRolle && (
                    <div>
                      <Label className="text-xs">Rolle in der App</Label>
                      <select value={editForm.app_role || ''} onChange={(e) => setEditForm(p => ({...p, app_role: e.target.value}))} className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm" data-testid="app-role-select">
                        <option value="">Mitglied (Standard)</option>
                        <option value="trainer">Trainer</option>
                        <option value="admin">Leitung</option>
                      </select>
                      {(editForm.app_role === 'trainer' || editForm.app_role === 'admin') && (
                        <p className="text-[10px] text-amber-600 mt-1 leading-snug">
                          Sieht Klassenlisten mit Notfallkontakten von Kindern, das Übergabeprotokoll
                          und öffnet die Tür ohne vorherigen Check-in. Nur an eigene Mitarbeiter vergeben.
                        </p>
                      )}
                      {(editForm.app_role === 'trainer' || editForm.app_role === 'admin') && (
                        <label className="mt-2 flex items-start gap-2 text-xs cursor-pointer" data-testid="app-headcoach">
                          <input type="checkbox" className="accent-marke mt-0.5" checked={!!editForm.app_headcoach} onChange={(e) => setEditForm(p => ({...p, app_headcoach: e.target.checked}))} />
                          <span><b>Headcoach</b> — darf im Trainingsplaner der App alle Zyklen bearbeiten und freigeben, nicht nur die eigenen.</span>
                        </label>
                      )}
                    </div>
                  )}

                  {/* Assign To Field */}
                  <div>
                    <Label className="text-xs">Zugewiesen an</Label>
                    <select 
                      value={editForm.assigned_to || ''} 
                      onChange={(e) => setEditForm(p => ({...p, assigned_to: e.target.value}))} 
                      className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm"
                    >
                      <option value="">Unassigned</option>
                      {agents.map(agent => (
                        <option key={agent.user_id} value={agent.user_id}>
                          {agent.name} ({agent.role})
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  {/* Custom Fields Edit */}
                  {settings.custom_fields_leads && settings.custom_fields_leads.length > 0 && (
                    <>
                      {settings.custom_fields_leads.map((field) => (
                        <div key={field.key}>
                          <Label className="text-xs">{field.label} {field.required && <span className="text-destructive">*</span>}</Label>
                          {field.type === 'text' && (
                            <Input 
                              value={editForm.custom_fields?.[field.key] || ''} 
                              onChange={(e) => setEditForm(p => ({
                                ...p, 
                                custom_fields: {...(p.custom_fields || {}), [field.key]: e.target.value}
                              }))} 
                            />
                          )}
                          {field.type === 'textarea' && (
                            <Textarea 
                              value={editForm.custom_fields?.[field.key] || ''} 
                              onChange={(e) => setEditForm(p => ({
                                ...p, 
                                custom_fields: {...(p.custom_fields || {}), [field.key]: e.target.value}
                              }))} 
                              rows={2}
                            />
                          )}
                          {field.type === 'number' && (
                            <Input 
                              type="number"
                              value={editForm.custom_fields?.[field.key] || ''} 
                              onChange={(e) => setEditForm(p => ({
                                ...p, 
                                custom_fields: {...(p.custom_fields || {}), [field.key]: parseFloat(e.target.value) || ''}
                              }))} 
                            />
                          )}
                          {field.type === 'select' && (
                            <select
                              value={editForm.custom_fields?.[field.key] || ''}
                              onChange={(e) => setEditForm(p => ({
                                ...p, 
                                custom_fields: {...(p.custom_fields || {}), [field.key]: e.target.value}
                              }))}
                              className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm"
                            >
                              <option value="">Select...</option>
                              {field.options?.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                              ))}
                            </select>
                          )}
                          {field.type === 'checkbox' && (
                            <div className="flex items-center gap-2 h-9">
                              <input
                                type="checkbox"
                                checked={editForm.custom_fields?.[field.key] || false}
                                onChange={(e) => setEditForm(p => ({
                                  ...p, 
                                  custom_fields: {...(p.custom_fields || {}), [field.key]: e.target.checked}
                                }))}
                                className="w-4 h-4"
                              />
                            </div>
                          )}
                          {field.type === 'date' && (
                            <Input 
                              type="date"
                              value={editForm.custom_fields?.[field.key] || ''} 
                              onChange={(e) => setEditForm(p => ({
                                ...p, 
                                custom_fields: {...(p.custom_fields || {}), [field.key]: e.target.value}
                              }))} 
                            />
                          )}
                        </div>
                      ))}
                    </>
                  )}
                  
                  <div><Label className="text-xs">Notes</Label><Textarea value={editForm.notes || ''} onChange={(e) => setEditForm(p => ({...p, notes: e.target.value}))} rows={3} maxLength={2000} /></div>
                  
                  {/* Save Actions - Sticky at bottom when editing */}
                  <div className="col-span-2 flex items-center justify-end gap-2 pt-4 border-t sticky bottom-0 bg-card/95 backdrop-blur-sm pb-2 -mb-2 z-10">
                    <Button 
                      variant="outline" 
                      onClick={() => { 
                        setEditing(false); 
                        setEditForm(lead); 
                        setEditErrors({}); 
                      }}
                      className="gap-1"
                    >
                      <X className="w-4 h-4" />
                      Abbrechen
                    </Button>
                    <Button 
                      onClick={handleSave} 
                      data-testid="save-lead-edit-bottom"
                      className="gap-1"
                    >
                      <Save className="w-4 h-4" />
                      Speichern
                    </Button>
                  </div>
                </div>
              ) : (
                <>
                  <InfoRow label="Quelle" value={toTitleCase(lead.source)} />
                  <InfoRow label="Bereich" value={(settings.bereiche || []).find(b => b.key === lead.bereich)?.label || (lead.bereich ? lead.bereich : '—')} />
                  <InfoRow label="Altersgruppe" value={(settings.altersgruppen || []).find(a => a.key === lead.altersgruppe)?.label || (lead.altersgruppe ? lead.altersgruppe : '—')} />
                  <InfoRow label="Kampagne" value={(settings.kampagnen || []).find(k => k.key === lead.kampagne)?.label || (lead.kampagne ? lead.kampagne : '—')} />
                  {lead.termin_status && <InfoRow label="Termin" value={lead.termin_status === 'geplant' ? 'Probetraining geplant' : lead.termin_status === 'besucht' ? 'Besucht' : lead.termin_status === 'no_show' ? 'No-Show' : 'Abgesagt'} />}
                  {(isAdminPermissions || !!(userPermissions || {})['leads.edit']) && (lead.termin_status === 'geplant' || (lead.termin_status === 'besucht' && lead.stage === 'probetraining_besucht')) && (
                    <div className="flex justify-end py-1" data-testid="lead-probetraining-baustein">
                      <ProbetrainingErgebnis pt={leadAlsPt} onFertig={() => { fetchLead?.(); fetchActivities?.(); }} navigate={navigate} nurFaellige={false} />
                    </div>
                  )}
                  {/* Wann genau das Probetraining stattfindet — kommt aus dem
                      Termin-Kern, sobald das Funnel-Formular ausgefüllt wurde. */}
                  {lead.probetraining?.start && (
                    <InfoRow label="Probetraining" value={
                      `${new Date(lead.probetraining.start).toLocaleString('de-DE', {
                        weekday: 'short', day: '2-digit', month: '2-digit',
                        hour: '2-digit', minute: '2-digit' })} Uhr`
                      + (lead.probetraining.kurs ? ` · ${lead.probetraining.kurs}` : '')
                    } />
                  )}
                  {lead.naechster_schritt && <InfoRow label="Nächster Schritt" value={schrittText(lead.naechster_schritt)} />}
                  <InfoRow label="Priorität" value={lead.priority === 'dringend' ? 'Dringend' : lead.priority === 'hoch' ? 'Hoch' : lead.priority === 'mittel' ? 'Mittel' : 'Niedrig'} />
                  {lead.belt && <InfoRow label="Gürtel" value={(settings.belt_progression || []).find(b => b.key === lead.belt)?.label || lead.belt} />}
                  {lead.app_role && <InfoRow label="Rolle in der App" value={lead.app_role === 'admin' ? 'Leitung' : lead.app_role === 'trainer' ? 'Trainer' : lead.app_role} />}
                  <InfoRow label="Zuständig" value={lead.assigned_to_name || '—'} />
                  <InfoRow label="Erstellt" value={formatDate(lead.created_at)} />
                  {lead.created_by_name && <InfoRow label="Angelegt von" value={lead.created_by_name} />}
                  {lead.probetraining?.gebucht_von && <InfoRow label="Probetraining eingetragen von" value={lead.probetraining.gebucht_von} />}
                  
                  {/* Custom Fields Display */}
                  {settings.custom_fields_leads && settings.custom_fields_leads.length > 0 && (
                    <>
                      {settings.custom_fields_leads.map((field) => {
                        const value = lead.custom_fields?.[field.key];
                        if (!value && value !== 0 && value !== false) return null;
                        
                        let displayValue = value;
                        if (field.type === 'select' || field.type === 'radio') {
                          displayValue = value;
                        } else if (field.type === 'checkbox') {
                          displayValue = value ? 'Yes' : 'No';
                        } else if (field.type === 'date') {
                          displayValue = formatDate(value);
                        }
                        
                        return <InfoRow key={field.key} label={field.label} value={displayValue} />;
                      })}
                    </>
                  )}
                  
                  {lead.notes && <div className="pt-2 border-t"><p className="text-xs text-muted-foreground">{lead.notes}</p></div>}
                </>
              )}
            </CardContent>
          </Card>

          {/* Lead-Einschätzung (v5, M1): Ampel, Kriterien, Risiken, eine Aktion */}
          <EinschaetzungPanel leadId={lead.id} />

          {/* AI Score */}
          {lead.ai_score && (
            <Card className="border-border/60 border-primary/20 bg-primary/5" data-testid="ai-score-card">
              <CardContent className="p-4 space-y-2">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Brain className="w-4 h-4 text-primary" />
                    <span className="text-xs font-semibold uppercase tracking-wider text-primary">AI Score</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className={`text-2xl font-bold ${
                      lead.ai_grade === 'A' ? 'text-green-600' :
                      lead.ai_grade === 'B' ? 'text-blue-600' :
                      lead.ai_grade === 'C' ? 'text-amber-600' : 'text-red-600'
                    }`}>{lead.ai_grade}</span>
                    <span className="text-sm text-muted-foreground">{lead.ai_score}/100</span>
                  </div>
                </div>
                {lead.ai_summary && <p className="text-xs text-muted-foreground leading-relaxed">{lead.ai_summary}</p>}
                {lead.ai_next_action && (
                  <div className="bg-background rounded-md p-2 border">
                    <p className="text-[10px] font-medium text-muted-foreground uppercase">Empfohlene Aktion</p>
                    <p className="text-xs mt-0.5">{lead.ai_next_action}</p>
                  </div>
                )}
                <p className="text-[9px] text-muted-foreground">Scored with {lead.ai_model_used} on {formatDate(lead.ai_scored_at)}</p>
              </CardContent>
            </Card>
          )}

          {/* v6: Vertrag abgeschlossen, Onboarding 0-30, Auto-Pflege-Felder, Sprachnotiz */}
          <DatenabgleichPanel leadId={id} onChange={fetchLead} />
          <OnboardingPanel leadId={id} lead={lead} onChange={fetchLead}
            darfVertrag={isAdminPermissions || userPermissions?.includes?.('verkauf.create_vertrag') || !!userPermissions?.['verkauf.create_vertrag']}
            darfBearbeiten={isAdminPermissions || !!(userPermissions || {})['leads.edit']} />

          {/* Upsell ohne neuen Vertrag (23.09.2026) — Zusatzvereinbarung an der laufenden Mitgliedschaft */}
          <GuertelKarte leadId={id} />
          {/* Check-Up (11.10.2026): eintragen, Tage, Kontingent — keine Messwerte (die stehen unter Ernährung › Mitglied).
              Erscheint nur bei Mitgliedern oder wenn schon ein Check-Up eingetragen ist. */}
          <div id="akte-checkup-karte" className="scroll-mt-4"><CheckupKarte leadId={id} mitLink neuLadenBei={ptStand} onGeaendert={() => setCheckupStand((n) => n + 1)} /></div>
          <TurniererfolgKarte key={`turnier-${id}`} leadId={id} darf={isAdminPermissions || !!(userPermissions || {})['leads.edit']} />
          {/* Check-Up-Ablauf (19.10.2026): Antworten, Plan und Messung aus der Trainer-App — nur lesen */}
          <CheckupErgebnisKarte key={`checkup-ergebnis-${id}`} leadId={id} />
          {/* P1 Coaching (12.10.2026): Paket verkaufen, Termine, Testwerte */}
          <div id="akte-coaching-karte" className="scroll-mt-4"><CoachingKarte key={`coaching-${id}`} leadId={id} rolle={user?.role} /></div>
          <ProbeplanKarte key={`probeplan-${id}`} leadId={id} leitung={['admin', 'manager'].includes(user?.role)} />
          <TeilnahmeKachel key={`teilnahme-${id}`} leadId={id} />
          <AdresseKarte key={`adresse-${id}`} leadId={id} darf={isAdminPermissions || !!(userPermissions || {})['leads.edit']} />
          <UpsellPanel key={id} leadId={id} autoOeffnen={new URLSearchParams(location.search).get('upsell') === '1'} autoDigital={new URLSearchParams(location.search).get('digital') === '1'} autoLaufzeit={new URLSearchParams(location.search).get('laufzeit') === '1'} />
          {/* Finanzkarte (03.11.2026): nur der Inhaber — offen, Einzug, Mandat, Beiträge, Rücklastschriften, Vorgemerktes */}
          <FinanzKarte key={`finanzen-${id}`} leadId={id} onRechnungen={darfRechnungen ? () => setReiter('rechnungen') : undefined} />

          {/* Quick stats */}
          <div className="grid grid-cols-2 gap-3">
            <Card className="border-border/60">
              <CardContent className="p-4 text-center">
                <p className="text-2xl font-bold">{lead.activity_count || 0}</p>
                <p className="text-[10px] text-muted-foreground uppercase tracking-wider">Aktivitäten</p>
              </CardContent>
            </Card>
            <Card className="border-border/60">
              <CardContent className="p-4 text-center">
                <p className="text-2xl font-bold">{trainingStats?.gesamt || 0}</p>
                <p className="text-[10px] text-muted-foreground uppercase tracking-wider">Trainings</p>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Right - Timeline */}
        <div className="lg:col-span-2 min-w-0">
          <Tabs value={reiter} onValueChange={setReiter}>
            {/* Reiter scrollen in ihrer Spalte, statt die Seite seitlich zu verbreitern */}
            <TabsList className="max-w-full overflow-x-auto justify-start">
              <TabsTrigger value="uebersicht" data-testid="tab-uebersicht">Übersicht</TabsTrigger>
              {darfFortschritt && <TabsTrigger value="fortschritt" data-testid="tab-fortschritt">Fortschritt</TabsTrigger>}
              {darfErnaehrung && <TabsTrigger value="ernaehrung" data-testid="tab-ernaehrung">Ernährung</TabsTrigger>}
              <TabsTrigger value="zeitstrahl" data-testid="tab-zeitstrahl">Zeitstrahl</TabsTrigger>
              <TabsTrigger value="timeline" data-testid="tab-timeline">Timeline</TabsTrigger>
              <TabsTrigger value="training" data-testid="tab-training">Trainingshistorie ({trainingStats?.gesamt || 0})</TabsTrigger>
              <TabsTrigger value="kraftlog" data-testid="tab-kraftlog">Training · Kraftlog</TabsTrigger>
              <TabsTrigger value="follow-ups" data-testid="tab-follow-ups">Follow-ups ({followUps.length})</TabsTrigger>
              <TabsTrigger value="einwilligungen" data-testid="tab-einwilligungen">Einwilligungen</TabsTrigger>
              <TabsTrigger value="familie" data-testid="tab-familie">Familie</TabsTrigger>
              <TabsTrigger value="dokumente" data-testid="tab-dokumente">Dokumente</TabsTrigger>
              {darfRechnungen && <TabsTrigger value="rechnungen" data-testid="tab-rechnungen">Rechnungen</TabsTrigger>}
              <TabsTrigger value="challenge" data-testid="tab-challenge">Challenge</TabsTrigger>
            </TabsList>

            <TabsContent value="uebersicht" className="mt-4" data-testid="uebersicht-tab">
              <AkteUebersicht leadId={id} akte={akte} fehler={akteFehler} onAktion={akteAktion} onVerlaufMehr={() => setReiter('zeitstrahl')} />
            </TabsContent>
            {darfFortschritt && (
              <TabsContent value="fortschritt" className="mt-4 space-y-3" data-testid="fortschritt-tab">
                {/* W2.4: „Fortschritt“ (Zeitraum, Statusleiste, Verläufe, Bilanz, Heatmap, Bildvergleich) und daneben die
                    bisherige Entwicklung (Check-in-Karte, Messwerte bearbeiten, Aktivitäten) — nur mit ernaehrung.view */}
                {darfErnaehrung && (
                  <div className="flex gap-1" role="tablist" aria-label="Ansicht Fortschritt">
                    {[['fortschritt', 'Fortschritt'], ['entwicklung', 'Entwicklung & Check-ins']].map(([w, n]) => (
                      <button key={w} type="button" role="tab" aria-selected={fortschrittAnsicht === w} onClick={() => setFortschrittAnsicht(w)}
                        className={`min-h-[40px] rounded-full border px-4 text-sm ${fortschrittAnsicht === w ? 'bg-foreground text-background border-foreground font-semibold' : 'bg-background hover:bg-muted'}`}>{n}</button>
                    ))}
                  </div>
                )}
                {reiter === 'fortschritt' && (!darfErnaehrung || fortschrittAnsicht === 'fortschritt') && <KundeFortschritt leadId={id} fuerTrainer />}
                {/* Brief 3.3: eingebettet, nicht neu gebaut — dieselbe Karte wie Ernährung › Mitglied › Entwicklung */}
                {reiter === 'fortschritt' && darfErnaehrung && fortschrittAnsicht === 'entwicklung' && <KundeEntwicklung leadId={id} onProtokoll={() => setReiter('ernaehrung')} />}
              </TabsContent>
            )}
            {darfErnaehrung && (
              <TabsContent value="ernaehrung" className="mt-4 space-y-3" data-testid="ernaehrung-tab">
                <p className="text-sm"><Link to={`/ernaehrung/${id}`} className="text-marke hover:underline">Ernährung › Mitglied öffnen</Link> <span className="text-muted-foreground">(Plan, Ziele, Formulare, Tresor)</span></p>
                {reiter === 'ernaehrung' && <Ernaehrungsprotokoll leadId={id} name={alsText(lead.name)} />}
              </TabsContent>
            )}

            <TabsContent value="zeitstrahl" className="mt-4">
              <KanalZeitstrahl stand={zeitstrahlStand} leadId={id} />
            </TabsContent>

            <TabsContent value="timeline" className="space-y-4 mt-4">
              <div className="flex justify-end gap-1.5 sm:gap-2 flex-wrap">
                {lead.phone && (isAdminPermissions || !!(userPermissions || {})['leads.edit']) && (
                  <Button size="sm" variant="outline" onClick={() => setSmsOffen(true)} data-testid="send-sms-btn" className="gap-1.5 text-blue-600 border-blue-200 dark:border-blue-900 hover:bg-blue-50 dark:hover:bg-blue-950/30">
                    <Phone className="w-3.5 h-3.5" /> SMS
                  </Button>
                )}
                <Button size="sm" variant="outline" data-testid="send-whatsapp-btn" className="gap-1.5 text-green-600 border-green-200 dark:border-green-900 hover:bg-green-50 dark:hover:bg-green-950/30"
                  title="WhatsApp-Verlauf im Posteingang öffnen (Brücke)"
                  onClick={async () => {
                    // Seit 18.09.2026: WhatsApp laeuft ueber die Bruecke und den Posteingang, nicht mehr ueber Twilio
                    try { const r = await superchatAPI.konversationFuerLead(id, 'whatsapp'); navigate(`/posteingang?konv=${r.data.konversation_id}`); }
                    catch (err) { toast.error(err.response?.data?.detail || 'WhatsApp-Verlauf konnte nicht geöffnet werden'); }
                  }}>
                  <MessageSquare className="w-3.5 h-3.5" /> WhatsApp
                </Button>
                <Button size="sm" variant="outline" onClick={() => setShowEmail(true)} data-testid="send-email-btn" className="gap-1.5 text-indigo-600 border-indigo-200 dark:border-indigo-900 hover:bg-indigo-50 dark:hover:bg-indigo-950/30">
                  <Mail className="w-3.5 h-3.5" /> E-Mail
                </Button>
                <Button size="sm" variant="outline" onClick={() => setShowAddActivity(true)} data-testid="add-activity-btn" className="gap-2">
                  <Plus className="w-4 h-4" /> Aktivität erfassen
                </Button>
              </div>
              <div className="space-y-0">
                {activities.map((act) => {
                  const Icon = getActivityIcon(act.type);
                  return (
                    <div key={act.id} className="flex gap-4 py-3 border-b border-border/40 last:border-0">
                      <div className="flex flex-col items-center">
                        <div className="w-8 h-8 rounded-full bg-muted flex items-center justify-center"><Icon className="w-3.5 h-3.5 text-muted-foreground" /></div>
                        <div className="flex-1 w-px bg-border/40 mt-2" />
                      </div>
                      <div className="flex-1 pb-2">
                        <div className="flex items-center justify-between">
                          <p className="text-sm font-medium capitalize">{act.type}</p>
                          <span className="text-[10px] mono text-muted-foreground">{formatDateTime(act.created_at)}</span>
                        </div>
                        {act.outcome && <Badge variant="secondary" className="text-[10px] mt-1">{act.outcome.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</Badge>}
                        {act.notes && <p className="text-xs text-muted-foreground mt-1">{act.notes}</p>}
                        {act.created_by_name && act.created_by_name !== 'Unknown' && <p className="text-[10px] text-muted-foreground mt-1">von {act.created_by_name}</p>}
                      </div>
                    </div>
                  );
                })}
                {activities.length === 0 && <p className="text-sm text-muted-foreground text-center py-8">No activities logged yet</p>}
              </div>
            </TabsContent>

            <TabsContent value="training" className="space-y-4 mt-4" data-testid="training-history-tab">
              <KurskontingentZeile leadId={id} />
              {['admin', 'manager'].includes(user?.role) && (isAdminPermissions || !!(userPermissions || {})['leads.edit']) && (
                <CheckinNachtragen memberId={id} onFertig={fetchTraining} />
              )}
              {/* Training Stats */}
              {trainingStats && (
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  <Card className="border-border/60">
                    <CardContent className="p-3 text-center">
                      <p className="text-lg font-bold">{trainingStats.gesamt}</p>
                      <p className="text-[10px] text-muted-foreground uppercase">Gesamt</p>
                    </CardContent>
                  </Card>
                  <Card className="border-border/60">
                    <CardContent className="p-3 text-center">
                      <p className="text-lg font-bold">{trainingStats.diesen_monat}</p>
                      <p className="text-[10px] text-muted-foreground uppercase">Diesen Monat</p>
                    </CardContent>
                  </Card>
                  <Card className="border-border/60">
                    <CardContent className="p-3 text-center">
                      <p className="text-lg font-bold">{trainingStats.diese_woche}</p>
                      <p className="text-[10px] text-muted-foreground uppercase">Diese Woche</p>
                    </CardContent>
                  </Card>
                  <Card className="border-border/60">
                    <CardContent className="p-3 text-center">
                      <p className="text-lg font-bold">{trainingStats.gesamt_minuten > 0 ? `${Math.round(trainingStats.gesamt_minuten / 60)}h` : '0h'}</p>
                      <p className="text-[10px] text-muted-foreground uppercase">Trainingszeit</p>
                    </CardContent>
                  </Card>
                </div>
              )}

              <div className="flex justify-end">
                <Button size="sm" variant="outline" onClick={() => setShowAddTraining(true)} data-testid="add-training-btn" className="gap-2">
                  <Plus className="w-4 h-4" /> Training erfassen
                </Button>
              </div>

              <div className="space-y-2">
                {trainingHistory.map((t) => (
                  <Card key={t.id} className="border-border/60" data-testid={`training-row-${t.id}`}>
                    <CardContent className="p-4 flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${t.quelle === 'checkin' ? 'bg-[#10B981]/10' : 'bg-marke/10'}`}>
                          <Dumbbell className={`w-4 h-4 ${t.quelle === 'checkin' ? 'text-[#10B981]' : 'text-marke'}`} />
                        </div>
                        <div>
                          <div className="flex items-center gap-2">
                            <p className="text-sm font-medium">{t.typ}</p>
                            {t.kurs && <Badge variant="outline" className="text-[10px]">{t.kurs}</Badge>}
                            <Badge variant="secondary" className="text-[10px]">
                              {t.quelle === 'checkin' ? 'Check-in' : 'Manuell'}
                            </Badge>
                          </div>
                          <div className="flex items-center gap-2 mt-0.5">
                            <p className="text-xs text-muted-foreground">
                              {t.datum ? new Date(t.datum).toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' }) : '—'}
                              {t.datum && ` — ${new Date(t.datum).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })}`}
                            </p>
                            {t.dauer_min > 0 && <span className="text-xs text-muted-foreground">• {t.dauer_min} Min.</span>}
                          </div>
                          {t.notizen && <p className="text-xs text-muted-foreground mt-1">{t.notizen}</p>}
                        </div>
                      </div>
                      {t.quelle === 'manuell' && (
                        <Button size="sm" variant="ghost" className="h-7 w-7 p-0 text-muted-foreground hover:text-destructive" onClick={async () => {
                          try {
                            await trainingAPI.delete(t.id);
                            toast.success('Trainingseinheit gelöscht');
                            fetchTraining();
                          } catch { toast.error('Löschen fehlgeschlagen'); }
                        }} data-testid={`delete-training-${t.id}`}>
                          <Trash2 className="w-3.5 h-3.5" />
                        </Button>
                      )}
                    </CardContent>
                  </Card>
                ))}
                {trainingHistory.length === 0 && (
                  <p className="text-sm text-muted-foreground text-center py-8">Noch keine Trainingseinheiten erfasst</p>
                )}
              </div>
            </TabsContent>

            <TabsContent value="follow-ups" className="space-y-4 mt-4">
              <div className="flex justify-end">
                <Button size="sm" variant="outline" onClick={() => setShowAddFollowUp(true)} data-testid="add-followup-btn" className="gap-2">
                  <Plus className="w-4 h-4" /> Nachfassung planen
                </Button>
              </div>
              {followUps.map((fu) => {
                const isOverdue = new Date(fu.due_date) < new Date() && fu.status === 'pending';
                return (
                  <Card key={fu.id} className={`border-border/60 ${isOverdue ? 'border-red-300 dark:border-red-900' : ''}`}>
                    <CardContent className="p-4 flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <Clock className={`w-4 h-4 ${isOverdue ? 'text-red-500' : 'text-muted-foreground'}`} />
                        <div>
                          <p className="text-sm font-medium capitalize">{fu.type}</p>
                          <p className="text-xs text-muted-foreground">{formatDate(fu.due_date)} {fu.notes && `- ${fu.notes}`}</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <Badge variant={fu.status === 'completed' ? 'default' : isOverdue ? 'destructive' : 'secondary'} className="text-[10px]">
                          {isOverdue ? 'Overdue' : fu.status}
                        </Badge>
                        {fu.status === 'pending' && (
                          <Button size="sm" variant="outline" className="h-7 text-xs" onClick={async () => {
                            await followUpsAPI.update(fu.id, { status: 'completed' });
                            toast.success('Als erledigt markiert');
                            fetchFollowUps();
                          }} data-testid={`complete-followup-${fu.id}`}>Erledigt</Button>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
              {followUps.length === 0 && <p className="text-sm text-muted-foreground text-center py-8">No follow-ups scheduled</p>}
            </TabsContent>

            <TabsContent value="einwilligungen" className="space-y-4 mt-4" data-testid="einwilligungen-tab">
              <ConsentOverview leadId={id} leadName={alsText(lead.name)} />
              {/* Keine Einwilligung, sondern ein Widerspruch — deshalb eigene Zeile, die selbst lädt
                  und auch dann steht, wenn die Einwilligungen nicht geladen werden konnten. */}
              <TeilnahmeNamenZeile leadId={id} />
            </TabsContent>

            <TabsContent value="dokumente" className="space-y-4 mt-4" data-testid="dokumente-tab-content">
              <DokumenteTab leadId={id} />
            </TabsContent>
            {darfRechnungen && (
              <TabsContent value="rechnungen" className="space-y-4 mt-4" data-testid="rechnungen-tab-content">
                <MitgliedRechnungen leadId={id} />
              </TabsContent>
            )}

            <TabsContent value="familie" className="space-y-4 mt-4" data-testid="familie-tab">
              <FamilyBlock leadId={id} leadName={alsText(lead.name)} />
            </TabsContent>
            <TabsContent value="kraftlog" className="mt-4" data-testid="kraftlog-tab">
              {/* Der PT-Zugang hängt am Check-Up: Ändert die Karte „Check-Up“ etwas, laden beide neu (und umgekehrt) */}
              <KraftlogPtZugang key={`${id}:${checkupStand}`} leadId={id} onGeaendert={() => setPtStand((n) => n + 1)} />
              <TrainingslogTab leadId={id} stand={ptStand + checkupStand} />
              <div className="mt-4"><CoachChatCrm leadId={id} /></div>
              <div className="mt-4"><GewohnheitenCrm leadId={id} /></div>
              <div className="mt-4"><LeistungstestsCrm leadId={id} /></div>
              <div className="mt-4"><FortschrittsfotosCrm leadId={id} /></div>
              <div className="mt-4"><TechnikVideosCrm leadId={id} /></div>
            </TabsContent>

            <TabsContent value="challenge" className="space-y-4 mt-4" data-testid="challenge-tab">
              <ChallengeBlock leadId={id} darfVerkauf={isAdminPermissions || userPermissions?.includes?.('verkauf.create_vertrag')} />
            </TabsContent>
          </Tabs>
        </div>
      </div>

      {/* Add Activity Dialog */}
      <AddActivityDialog open={showAddActivity} onClose={() => setShowAddActivity(false)} leadId={id} onSuccess={() => { fetchActivities(); fetchLead(); }} />
      <AddFollowUpDialog open={showAddFollowUp} onClose={() => setShowAddFollowUp(false)} leadId={id} onSuccess={fetchFollowUps} />
      <AddTrainingDialog open={showAddTraining} onClose={() => setShowAddTraining(false)} leadId={id} onSuccess={fetchTraining} />
      <SendMessageDialog open={!!showSendMessage} channel={showSendMessage} onClose={() => setShowSendMessage(null)} lead={lead} onSuccess={() => { fetchActivities(); }} />
      {/* SMS über das Vertriebshandy: hier unten, damit der Dialog auch im Bearbeiten-Modus eingehängt ist */}
      <SmsDialog leadId={smsOffen ? id : null} onClose={() => setSmsOffen(false)} onFertig={() => { fetchActivities?.(); setZeitstrahlStand(n => n + 1); }} />
      <EmailSendenDialog open={showEmail} onClose={() => setShowEmail(false)} lead={lead} user={user} onSuccess={() => { fetchActivities(); }} />
    </div>
  );
}

function InfoRow({ label, value }) {
  return (
    <div className="flex justify-between">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-medium capitalize">{alsText(value) || '—'}</span>
    </div>
  );
}

function AddActivityDialog({ open, onClose, leadId, onSuccess }) {
  const [type, setType] = useState('call');
  const [outcome, setOutcome] = useState('positive');
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);
  const { settings } = useSettings();
  const activityTypes = (settings.activity_types || []).map(t => typeof t === 'object' ? t : { key: t, label: t });
  const outcomes = settings.activity_outcomes || ['positive', 'neutral', 'negative', 'no_answer', 'callback_requested'];
  
  // Title case helper

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await activitiesAPI.create({ lead_id: leadId, type, outcome, notes });
      toast.success('Aktivität gespeichert');
      onSuccess();
      onClose();
      setType('call'); setOutcome('positive'); setNotes('');
    } catch { toast.error('Fehlgeschlagen'); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="add-activity-dialog">
        <DialogHeader><DialogTitle>Aktivität erfassen</DialogTitle></DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label>Type</Label>
            <select value={type} onChange={(e) => setType(e.target.value)} className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm">
              {activityTypes.map(t => <option key={t.key} value={t.key}>{t.label}</option>)}
            </select>
          </div>
          <div>
            <Label>Outcome</Label>
            <select value={outcome} onChange={(e) => setOutcome(e.target.value)} className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm">
              {outcomes.map(o => <option key={o} value={o}>{toTitleCase(o)}</option>)}
            </select>
          </div>
          <div>
            <Label>Notes</Label>
            <Textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={3} />
          </div>
          <DialogFooter>
            <Button variant="outline" type="button" onClick={onClose}>Abbrechen</Button>
            <Button type="submit" disabled={saving} data-testid="save-activity-btn">{saving ? 'Wird gespeichert...' : 'Aktivität speichern'}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

function AddFollowUpDialog({ open, onClose, leadId, onSuccess }) {
  const [type, setType] = useState('call');
  const [dueDate, setDueDate] = useState('');
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);
  const { settings } = useSettings();
  const followUpTypes = (settings.follow_up_types || []).map(t => typeof t === 'object' ? t : { key: t, label: t });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await followUpsAPI.create({ lead_id: leadId, type, due_date: new Date(dueDate).toISOString(), notes });
      toast.success('Nachfassung geplant');
      onSuccess();
      onClose();
    } catch { toast.error('Fehlgeschlagen'); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="add-followup-dialog">
        <DialogHeader><DialogTitle>Nachfassung planen</DialogTitle></DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div><Label>Type</Label>
            <select value={type || ""} onChange={(e) => setType(e.target.value)} className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50">
{followUpTypes.map(t => <option key={t.key} value={t.key}>{t.label}</option>)}
</select>
          </div>
          <div><Label>Due Date</Label><Input type="datetime-local" value={dueDate} onChange={(e) => setDueDate(e.target.value)} required data-testid="followup-date-input" /></div>
          <div><Label>Notes</Label><Textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={2} /></div>
          <DialogFooter>
            <Button variant="outline" type="button" onClick={onClose}>Abbrechen</Button>
            <Button type="submit" disabled={saving || !dueDate} data-testid="save-followup-btn">{saving ? 'Saving...' : 'Schedule'}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}


function AddTrainingDialog({ open, onClose, leadId, onSuccess }) {
  const [typ, setTyp] = useState('Training');
  const [kurs, setKurs] = useState('');
  const [dauer, setDauer] = useState('60');
  const [notizen, setNotizen] = useState('');
  const [datum, setDatum] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await trainingAPI.create({
        member_id: leadId,
        typ,
        kurs: kurs || null,
        dauer_min: parseInt(dauer, 10) || 60,
        notizen: notizen || null,
        datum: datum ? new Date(datum).toISOString() : null,
      });
      toast.success('Trainingseinheit erfasst');
      onSuccess();
      onClose();
      setTyp('Training'); setKurs(''); setDauer('60'); setNotizen(''); setDatum('');
    } catch { toast.error('Fehler beim Erfassen'); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="add-training-dialog">
        <DialogHeader><DialogTitle>Training erfassen</DialogTitle></DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label className="text-xs">Typ</Label>
            <select value={typ} onChange={(e) => setTyp(e.target.value)} className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm" data-testid="training-typ-select">
              <option value="Training">Training</option>
              <option value="Probetraining">Probetraining</option>
              <option value="Personaltraining">Personaltraining</option>
              <option value="Kurs">Kurs</option>
              <option value="Open Mat">Open Mat</option>
              <option value="Wettkampf">Wettkampf</option>
            </select>
          </div>
          <div>
            <Label className="text-xs">Kurs / Beschreibung (optional)</Label>
            <Input value={kurs} onChange={(e) => setKurs(e.target.value)} placeholder="z.B. BJJ Grundlagen, Boxen..." data-testid="training-kurs-input" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="text-xs">Datum & Uhrzeit</Label>
              <Input type="datetime-local" value={datum} onChange={(e) => setDatum(e.target.value)} data-testid="training-datum-input" />
            </div>
            <div>
              <Label className="text-xs">Dauer (Minuten)</Label>
              <Input type="number" min="1" max="480" value={dauer} onChange={(e) => setDauer(e.target.value)} data-testid="training-dauer-input" />
            </div>
          </div>
          <div>
            <Label className="text-xs">Notizen</Label>
            <Textarea value={notizen} onChange={(e) => setNotizen(e.target.value)} rows={2} placeholder="Optionale Anmerkungen..." />
          </div>
          <DialogFooter>
            <Button variant="outline" type="button" onClick={onClose}>Abbrechen</Button>
            <Button type="submit" disabled={saving} data-testid="save-training-btn">{saving ? 'Wird gespeichert...' : 'Training speichern'}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}


function SendMessageDialog({ open, channel, onClose, lead, onSuccess }) {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [message, setMessage] = useState('');
  const [subject, setSubject] = useState('');
  const [toValue, setToValue] = useState('');
  const [sending, setSending] = useState(false);
  const [configLoaded, setConfigLoaded] = useState(false);
  const isEmail = channel === 'email';

  useEffect(() => {
    if (open && lead) {
      setToValue(isEmail ? (lead.email || '') : (lead.phone || ''));
      setSubject(''); setMessage(''); setSelectedTemplate('');
      if (isEmail) {
        integrationsAPI.getEmailConfig().then(res => {
          setTemplates(res.data.templates || []);
          setConfigLoaded(!!res.data.email_enabled);
        }).catch(() => setConfigLoaded(false));
      } else {
        integrationsAPI.get().then(res => {
          const key = channel === 'sms' ? 'sms_templates' : 'whatsapp_templates';
          setTemplates(res.data[key] || []);
          setConfigLoaded(channel === 'sms' ? res.data.sms_enabled : res.data.whatsapp_enabled);
        }).catch(() => setConfigLoaded(false));
      }
    }
  }, [open, lead, channel, isEmail]);

  const handleTemplateSelect = (tmplId) => {
    setSelectedTemplate(tmplId);
    const tmpl = templates.find(t => t.id === tmplId);
    if (tmpl) { setMessage(tmpl.body); if (tmpl.subject) setSubject(tmpl.subject); }
  };

  const handleSend = async (e) => {
    e.preventDefault();
    if (!toValue || !message) return;
    setSending(true);
    try {
      if (isEmail) {
        await integrationsAPI.sendEmail({ lead_id: lead.id, to_email: toValue, subject, body: message });
      } else {
        const api = channel === 'sms' ? integrationsAPI.sendSMS : integrationsAPI.sendWhatsApp;
        await api({ lead_id: lead.id, to_number: toValue, message });
      }
      toast.success(`${channel === 'sms' ? 'SMS' : channel === 'whatsapp' ? 'WhatsApp' : 'Email'} sent`);
      onSuccess(); onClose();
    } catch (err) { toast.error(err.response?.data?.detail || 'Failed to send'); }
    finally { setSending(false); }
  };

  const icons = { sms: Phone, whatsapp: MessageSquare, email: Mail };
  const colors = { sms: 'text-blue-500', whatsapp: 'text-green-500', email: 'text-indigo-500' };
  const labels = { sms: 'SMS', whatsapp: 'WhatsApp', email: 'Email' };
  const Icon = icons[channel] || Phone;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="send-message-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Icon className={`w-4 h-4 ${colors[channel]}`} />
            Send {labels[channel]} to {lead?.name}
          </DialogTitle>
        </DialogHeader>
        {!configLoaded ? (
          <div className="py-6 text-center text-sm text-muted-foreground">
            <p>{labels[channel]} integration is not enabled.</p>
            <p className="text-xs mt-1">Ask your admin to configure it in Integrations.</p>
          </div>
        ) : (
          <form onSubmit={handleSend} className="space-y-4">
            <div>
              <Label className="text-xs">{isEmail ? 'To Email' : 'To Number'}</Label>
              <Input value={toValue} onChange={(e) => setToValue(e.target.value)} placeholder={isEmail ? 'lead@example.com' : '+14155551234'} className={`text-xs ${isEmail ? '' : 'mono'}`} required data-testid="msg-to-value" />
            </div>
            {templates.length > 0 && (
              <div>
                <Label className="text-xs">Template (optional)</Label>
                <select value={selectedTemplate || ""} onChange={(e) => handleTemplateSelect(e.target.value)} className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50">
{templates.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
</select>
              </div>
            )}
            {isEmail && (
              <div>
                <Label className="text-xs">Subject</Label>
                <Input value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Betreff..." className="text-xs" required data-testid="msg-subject" />
              </div>
            )}
            <div>
              <Label className="text-xs">{isEmail ? 'Body' : 'Message'}</Label>
              <Textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={isEmail ? 6 : 4} required data-testid="msg-body" />
              <p className="text-[9px] text-muted-foreground mt-1">Variables like {'{lead_name}'} will be auto-replaced</p>
            </div>
            <DialogFooter>
              <Button variant="outline" type="button" onClick={onClose}>Abbrechen</Button>
              <Button type="submit" disabled={sending || !toValue || !message} data-testid="send-msg-btn" className="gap-1.5">
                {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                {sending ? 'Sending...' : 'Send'}
              </Button>
            </DialogFooter>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}

// ─── Einwilligungen je Mitglied (Feature 2) ───
const CONSENT_TYPES_ORDER = ['waiver', 'foto_video', 'dsgvo', 'hausordnung'];

function ConsentOverview({ leadId, leadName }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [recordType, setRecordType] = useState(null); // Typ, der gerade erfasst wird
  const [form, setForm] = useState({ signed_by_name: '', g_name: '', g_confirmed: false, g_email: '', g_phone: '' });
  const [saving, setSaving] = useState(false);
  // Widerruf einer freiwilligen Einwilligung erfassen (11.10.2026)
  const [widerrufType, setWiderrufType] = useState(null);
  const [wForm, setWForm] = useState({ erklaert_von: '', gilt_ab: '', grund: '' });

  const widerrufen = async () => {
    if (wForm.erklaert_von.trim().length < 2) { toast.error('Wer hat den Widerruf erklärt?'); return; }
    setSaving(true);
    try {
      await dsgvoAPI.consentWiderruf({ lead_id: leadId, type: widerrufType, erklaert_von: wForm.erklaert_von.trim(), gilt_ab: wForm.gilt_ab || undefined, grund: wForm.grund.trim() || undefined });
      toast.success('Widerruf erfasst');
      setWiderrufType(null);
      load();
    } catch (err) { const d = err?.response?.data?.detail; toast.error(typeof d === 'string' ? d : 'Widerruf konnte nicht erfasst werden'); }
    finally { setSaving(false); }
  };

  const load = async () => {
    setLoading(true);
    try {
      const res = await dsgvoAPI.consentOverview(leadId);
      setData(res.data);
    } catch { toast.error('Einwilligungen konnten nicht geladen werden'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, [leadId]);

  const isMinor = data?.is_minor ?? false;
  const startRecord = (type) => {
    setRecordType(type);
    setForm({ signed_by_name: '', g_name: '', g_confirmed: false, g_email: '', g_phone: '' });
  };

  const canSave = form.signed_by_name.trim().length > 1 &&
    (!isMinor || (form.g_name.trim().length > 1 && form.g_confirmed && (form.g_email.trim() || form.g_phone.trim())));

  const save = async () => {
    if (!canSave) return;
    setSaving(true);
    try {
      await dsgvoAPI.recordConsent({
        lead_id: leadId,
        type: recordType,
        signed_by_name: form.signed_by_name.trim(),
        ...(isMinor ? { guardian: { name: form.g_name.trim(), confirmed: form.g_confirmed, email: form.g_email.trim() || undefined, phone: form.g_phone.trim() || undefined } } : {}),
      });
      toast.success('Einwilligung erfasst');
      setRecordType(null);
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || 'Erfassen fehlgeschlagen'); }
    finally { setSaving(false); }
  };

  if (loading) return <p className="text-sm text-muted-foreground py-4">Lade…</p>;
  if (!data) return null;

  const byType = Object.fromEntries((data.consents || []).map(c => [c.type, c]));
  const ordered = CONSENT_TYPES_ORDER.map(t => byType[t]).filter(Boolean);

  return (
    <div className="space-y-3">
      {isMinor && (
        <div className="flex items-center gap-2 rounded-md bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 p-2.5">
          <FileText className="w-4 h-4 text-amber-600 flex-shrink-0" />
          <p className="text-xs text-amber-700 dark:text-amber-400">Minderjährig — Einwilligung nur durch Erziehungsberechtigte/n (Angaben Pflicht).</p>
        </div>
      )}

      {ordered.map(c => (
        <Card key={c.type} className="border-border/60">
          <CardContent className="p-3">
            <div className="flex items-center justify-between gap-3">
              <div className="min-w-0">
                <p className="text-sm font-medium">{c.title}</p>
                {c.signed ? (
                  <p className="text-xs text-emerald-600 dark:text-emerald-400">
                    ✓ Unterschrieben ({c.text_version}){c.signed_by_name ? ` · ${c.signed_by_name}` : ''}{c.via_guardian ? ' · via Erziehungsberechtigte/r' : ''}
                  </p>
                ) : c.widerruf ? (
                  <p className="text-xs text-red-600 dark:text-red-400" data-testid={`consent-widerrufen-${c.type}`}>
                    Widerrufen{c.widerruf.gilt_ab ? ` · gilt seit ${String(c.widerruf.gilt_ab).split('-').reverse().join('.')} nicht mehr` : ` am ${String(c.widerruf.am || '').slice(0, 10).split('-').reverse().join('.')}`}{c.widerruf.erklaert_von ? ` · erklärt von ${c.widerruf.erklaert_von}` : ''}{c.type === 'foto_video' ? ' · Trainer sehen „Keine Fotos“' : ''}
                  </p>
                ) : (
                  <p className="text-xs text-amber-600 dark:text-amber-400">Offen</p>
                )}
              </div>
              {c.signed && c.widerrufbar_crm && widerrufType !== c.type && (
                <Button size="sm" variant="outline" className="text-red-600" onClick={() => { setWiderrufType(c.type); setWForm({ erklaert_von: '', gilt_ab: '', grund: '' }); }} data-testid={`widerruf-consent-${c.type}`}>
                  Widerruf erfassen
                </Button>
              )}
              {!c.signed && recordType !== c.type && (
                <Button size="sm" variant="outline" onClick={() => startRecord(c.type)} data-testid={`record-consent-${c.type}`}>
                  Erfassen
                </Button>
              )}
            </div>

            {widerrufType === c.type && (
              <div className="mt-3 pt-3 border-t border-border/50 space-y-2">
                <p className="text-xs text-muted-foreground">Der unterschriebene Vertrag bleibt unverändert. Der Widerruf wird als eigener Eintrag gespeichert und gilt für die Zukunft.</p>
                <Label className="text-xs">Wer hat den Widerruf erklärt?</Label>
                <Input value={wForm.erklaert_von} onChange={e => setWForm(f => ({ ...f, erklaert_von: e.target.value }))} placeholder="Vor- und Nachname (Mitglied oder Elternteil)" data-testid="widerruf-erklaert-von" />
                <div className="grid grid-cols-2 gap-2">
                  <div><Label className="text-xs">Gilt seit (leer = heute)</Label><Input type="date" value={wForm.gilt_ab} onChange={e => setWForm(f => ({ ...f, gilt_ab: e.target.value }))} data-testid="widerruf-gilt-ab" /></div>
                  <div><Label className="text-xs">Bemerkung (optional)</Label><Input value={wForm.grund} onChange={e => setWForm(f => ({ ...f, grund: e.target.value }))} placeholder="z. B. per E-Mail erklärt" /></div>
                </div>
                <div className="flex justify-end gap-2 pt-1">
                  <Button size="sm" variant="ghost" onClick={() => setWiderrufType(null)}>Abbrechen</Button>
                  <Button size="sm" onClick={widerrufen} disabled={saving} data-testid={`save-widerruf-${c.type}`}>{saving ? 'Speichert…' : 'Widerruf erfassen'}</Button>
                </div>
              </div>
            )}

            {recordType === c.type && (
              <div className="mt-3 pt-3 border-t border-border/50 space-y-2">
                <Label className="text-xs">{isMinor ? 'Name des unterschreibenden Elternteils' : 'Name der unterschreibenden Person'}</Label>
                <Input value={form.signed_by_name} onChange={e => setForm(f => ({ ...f, signed_by_name: e.target.value }))} placeholder="Vor- und Nachname" />
                {isMinor && (
                  <>
                    <Label className="text-xs mt-2 block">Name Erziehungsberechtigte/r</Label>
                    <Input value={form.g_name} onChange={e => setForm(f => ({ ...f, g_name: e.target.value }))} placeholder="Vor- und Nachname" />
                    <label className="flex items-center gap-2 text-xs mt-1 cursor-pointer">
                      <input type="checkbox" checked={form.g_confirmed} onChange={e => setForm(f => ({ ...f, g_confirmed: e.target.checked }))} />
                      Ich bestätige, erziehungsberechtigt zu sein.
                    </label>
                    <div className="grid grid-cols-2 gap-2 mt-1">
                      <Input value={form.g_email} onChange={e => setForm(f => ({ ...f, g_email: e.target.value }))} placeholder="E-Mail" />
                      <Input value={form.g_phone} onChange={e => setForm(f => ({ ...f, g_phone: e.target.value }))} placeholder="Telefon" />
                    </div>
                  </>
                )}
                <div className="flex justify-end gap-2 pt-1">
                  <Button size="sm" variant="ghost" onClick={() => setRecordType(null)}>Abbrechen</Button>
                  <Button size="sm" onClick={save} disabled={!canSave || saving} data-testid={`save-consent-${c.type}`}>
                    {saving ? 'Speichert…' : 'Einwilligung erfassen'}
                  </Button>
                </div>
              </div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}

// ─── Teilnehmerliste in der App („Wer kommt noch?“) je Mitglied ───
/* Zeigt, ob der Vorname dieses Mitglieds in der App für andere Mitglieder sichtbar ist, und
   lässt ihn am Empfang ausblenden (Widerspruch) oder das Ausblenden aufheben.
   - Streng gelesen: nur exakt true gilt. Ein fehlender oder kaputter Wert darf nie wie
     „sichtbar“ oder „eingeschaltet“ aussehen.
   - Bei 403/404 bleibt die Zeile weg (kein Recht bzw. kein solcher Lead).
   - Kein window.confirm: beide Richtungen wirken sofort und lassen sich zurücknehmen. */
function TeilnahmeNamenZeile({ leadId }) {
  // null = lädt oder nicht zeigen (403/404) · 'fehler' = Laden gescheitert · sonst Antwort des Servers
  const [stand, setStand] = useState(null);
  const [busy, setBusy] = useState(false);
  // Die Seite blättert zwischen Leads, ohne neu aufgebaut zu werden: eine verspätete Antwort
  // zum vorigen Lead darf nicht in der Zeile des neuen landen.
  const aktuell = useRef(leadId);

  const lade = useCallback(async () => {
    try {
      const d = (await teilnehmerlisteAPI.mitglied(leadId)).data;
      if (aktuell.current !== leadId) return;
      setStand(d && typeof d === 'object' && !Array.isArray(d) ? d : 'fehler');
    } catch (err) {
      if (aktuell.current !== leadId) return;
      const status = err?.response?.status;
      setStand(status === 403 || status === 404 ? null : 'fehler');
    }
  }, [leadId]);

  useEffect(() => {
    aktuell.current = leadId;
    setStand(null);
    setBusy(false);
    lade();
    return () => { aktuell.current = null; };
  }, [leadId, lade]);

  const setzen = async (ausgeblendet) => {
    setBusy(true);
    try {
      await teilnehmerlisteAPI.mitgliedSetzen(leadId, ausgeblendet);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === 'string' && detail ? detail : 'Nicht gespeichert');
    }
    // In beiden Fällen neu laden: die Zeile soll zeigen, was wirklich gilt.
    await lade();
    if (aktuell.current === leadId) setBusy(false);
  };

  if (stand === null) return null;

  let satz;
  let knopf = null;
  if (stand === 'fehler') {
    satz = 'Der Stand konnte nicht geladen werden.';
    knopf = <Button size="sm" variant="outline" onClick={lade} data-testid="teilnahme-namen-neu-laden">Erneut laden</Button>;
  } else {
    const ausblenden = (
      <Button size="sm" variant="outline" disabled={busy} onClick={() => setzen(true)} data-testid="teilnahme-namen-ausblenden">
        Ausblenden
      </Button>
    );
    if (stand.ausgeblendet === true) {
      satz = 'Vorname ausgeblendet.';
      knopf = (
        <Button size="sm" variant="outline" disabled={busy} onClick={() => setzen(false)} data-testid="teilnahme-namen-aufheben">
          Ausblenden aufheben
        </Button>
      );
    } else if (stand.sichtbar === true) {
      satz = 'Vorname ist für andere Mitglieder sichtbar.';
      knopf = ausblenden;
    } else if (stand.moeglich === true) {
      satz = 'Vorname erscheint, sobald das Mitglied den Hinweis in der App gesehen hat.';
      knopf = ausblenden;
    } else {
      satz = 'Vorname wird nie gezeigt (kein laufendes Mitglied, minderjährig oder Alter ungeklärt).';
    }
    if (stand.aktiv !== true) satz += ' Die Funktion ist derzeit ausgeschaltet.';
  }

  return (
    <Card className="border-border/60" data-testid="teilnahme-namen-zeile">
      <CardContent className="p-3">
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0">
            <p className="text-sm font-medium">Teilnehmerliste in der App</p>
            <p className="text-xs text-muted-foreground" data-testid="teilnahme-namen-satz">{satz}</p>
          </div>
          {knopf && <div className="shrink-0">{knopf}</div>}
        </div>
      </CardContent>
    </Card>
  );
}

// ─── Familie: Verknüpfungen (Empfang) ───
function FamilyBlock({ leadId, leadName }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [suche, setSuche] = useState('');
  const [treffer, setTreffer] = useState([]);
  const [rolle, setRolle] = useState('verwalter');
  const [busy, setBusy] = useState(false);
  // Elternkonto aus den Angaben der Erziehungsberechtigten / Kinder vom Elternprofil (30.09.2026)
  const [elternVorschlag, setElternVorschlag] = useState(null);
  const [kindSuche, setKindSuche] = useState('');
  const [kindTreffer, setKindTreffer] = useState([]);
  const [neuesKind, setNeuesKind] = useState({ vorname: '', nachname: '', geburtsdatum: '' });

  const load = async () => {
    setLoading(true);
    try {
      const res = await familyAPI.ofLead(leadId);
      setData(res.data);
    } catch { toast.error('Familie konnte nicht geladen werden'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, [leadId]);
  useEffect(() => {
    if (!data || data.verwaltet_von.length) { setElternVorschlag(null); return; }
    api.get(`/leads/${leadId}/elternkonto`).then(r => setElternVorschlag(r.data)).catch(() => setElternVorschlag(null));
  }, [data, leadId]);

  const elternkontoAnlegen = async () => {
    setBusy(true);
    try {
      const r = (await api.post(`/leads/${leadId}/elternkonto`, {})).data;
      toast.success(r.neu ? `Elternkonto ${r.eltern.name} angelegt und verknüpft` : `Mit ${r.eltern.name} verknüpft`);
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || 'Elternkonto nicht angelegt'); }
    finally { setBusy(false); }
  };
  const kindSuchen = async () => {
    if (!kindSuche.trim()) return;
    try {
      const res = await leadsAPI.getAll({ search: kindSuche, limit: 8 });
      setKindTreffer((res.data.leads || res.data || []).filter(l => l.id !== leadId));
    } catch { toast.error('Suche fehlgeschlagen'); }
  };
  const kindVerknuepfen = async (kind) => {
    setBusy(true);
    try {
      await familyAPI.link(kind.id, leadId, 'verwalter');
      toast.success(`${kind.name} ist jetzt Kind von ${leadName}`);
      setKindSuche(''); setKindTreffer([]); load();
    } catch (err) { toast.error(err?.response?.data?.detail || 'Verknüpfen fehlgeschlagen'); }
    finally { setBusy(false); }
  };
  const kindNeu = async () => {
    if (!neuesKind.vorname.trim()) { toast.error('Vorname des Kindes fehlt'); return; }
    setBusy(true);
    try {
      const r = (await api.post(`/leads/${leadId}/kind`, { ...neuesKind, geburtsdatum: neuesKind.geburtsdatum || null })).data;
      toast.success(`${r.name} angelegt und verknüpft`);
      setNeuesKind({ vorname: '', nachname: '', geburtsdatum: '' }); load();
    } catch (err) { toast.error(err?.response?.data?.detail || 'Kind nicht angelegt'); }
    finally { setBusy(false); }
  };

  const suchen = async () => {
    if (!suche.trim()) return;
    try {
      const res = await leadsAPI.getAll({ search: suche, limit: 8 });
      setTreffer((res.data.leads || res.data || []).filter(l => l.id !== leadId));
    } catch { toast.error('Suche fehlgeschlagen'); }
  };

  // Dieses Profil (Kind) mit einem KONTO verknüpfen
  const verknuepfen = async (konto) => {
    setBusy(true);
    try {
      await familyAPI.link(leadId, konto.id, rolle);
      toast.success(`Mit Konto von ${konto.name} verknüpft (${rolle})`);
      setSuche(''); setTreffer([]);
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || 'Verknüpfen fehlgeschlagen'); }
    finally { setBusy(false); }
  };

  const loesen = async (profilId, accountId) => {
    if (!window.confirm('Verknüpfung wirklich lösen?')) return;
    try {
      await familyAPI.unlink(profilId, accountId);
      toast.success('Verknüpfung gelöst');
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || 'Fehler'); }
  };

  if (loading) return <p className="text-sm text-muted-foreground py-4">Lade…</p>;
  if (!data) return null;

  return (
    <div className="space-y-4">
      {/* Wird verwaltet von (dieses Profil als Kind) */}
      <Card className="border-border/60">
        <CardContent className="p-4 space-y-2">
          <p className="text-sm font-semibold">Wird verwaltet von</p>
          {data.verwaltet_von.length === 0 ? (
            <div className="space-y-2">
              <p className="text-xs text-muted-foreground">Kein Elternkonto verknüpft.</p>
              {elternVorschlag?.vorschlag && (
                <div className="flex flex-wrap items-center gap-2 rounded-md border border-border/60 p-2 text-xs">
                  <span>Laut Vertrag: <b>{elternVorschlag.vorschlag.name}</b>{elternVorschlag.vorschlag.email ? ` · ${elternVorschlag.vorschlag.email}` : ''}</span>
                  <Button size="sm" className="h-7" disabled={busy} onClick={elternkontoAnlegen} data-testid="elternkonto-anlegen">
                    {elternVorschlag.vorhanden ? `Mit ${elternVorschlag.vorhanden.name} verknüpfen` : 'Elternkonto anlegen & verknüpfen'}
                  </Button>
                </div>
              )}
            </div>
          ) : data.verwaltet_von.map(g => (
            <div key={g.id} className="flex items-center justify-between gap-2 text-sm">
              <span>{g.lead.name} <Badge variant="outline" className="ml-1 text-[10px]">{g.rolle}</Badge></span>
              <Button size="sm" variant="ghost" className="h-7 text-red-500" onClick={() => loesen(g.profil_id, g.account_id)} data-testid={`unlink-${g.id}`}>Lösen</Button>
            </div>
          ))}
        </CardContent>
      </Card>

      {/* Verwaltet (dieses Profil als Elternkonto) */}
      <Card className="border-border/60">
        <CardContent className="p-4 space-y-2">
          <p className="text-sm font-semibold">Verwaltet</p>
          {data.verwaltet.length === 0 ? (
            <p className="text-xs text-muted-foreground">Keine Kinderprofile verknüpft.</p>
          ) : data.verwaltet.map(g => (
            <div key={g.id} className="flex items-center justify-between gap-2 text-sm">
              <span>{g.lead.name}{g.lead.birthday ? ` · *${g.lead.birthday}` : ''} <Badge variant="outline" className="ml-1 text-[10px]">{g.rolle}</Badge></span>
              <Button size="sm" variant="ghost" className="h-7 text-red-500" onClick={() => loesen(g.profil_id, g.account_id)}>Lösen</Button>
            </div>
          ))}
          {/* Kinder vom Elternprofil aus hinzufügen — mehrere nacheinander */}
          <div className="border-t border-border/40 pt-3 space-y-2" data-testid="kind-hinzufuegen">
            <p className="text-xs font-semibold">Kind hinzufügen</p>
            <div className="flex gap-2">
              <Input placeholder="Bestehendes Kind suchen (Name)…" value={kindSuche} onChange={e => setKindSuche(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && kindSuchen()} className="h-8" />
              <Button size="sm" variant="outline" onClick={kindSuchen}>Suchen</Button>
            </div>
            {kindTreffer.map(t => (
              <div key={t.id} className="flex items-center justify-between gap-2 text-sm">
                <span>{t.name} <span className="text-xs text-muted-foreground">{t.birthday || t.email || ''}</span></span>
                <Button size="sm" className="h-7" disabled={busy} onClick={() => kindVerknuepfen(t)}>Als Kind verknüpfen</Button>
              </div>
            ))}
            <div className="grid grid-cols-1 sm:grid-cols-[1fr_1fr_140px_auto] gap-2 items-center">
              <Input placeholder="Vorname" value={neuesKind.vorname} onChange={e => setNeuesKind({ ...neuesKind, vorname: e.target.value })} className="h-8" />
              <Input placeholder="Nachname (wie Elternteil)" value={neuesKind.nachname} onChange={e => setNeuesKind({ ...neuesKind, nachname: e.target.value })} className="h-8" />
              <Input type="date" value={neuesKind.geburtsdatum} onChange={e => setNeuesKind({ ...neuesKind, geburtsdatum: e.target.value })} className="h-8" />
              <Button size="sm" className="h-8" disabled={busy} onClick={kindNeu} data-testid="kind-neu">Neues Kind</Button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Verknüpfen: dieses Profil (Kind) einem Elternkonto zuordnen */}
      <Card className="border-border/60">
        <CardContent className="p-4 space-y-2">
          <p className="text-sm font-semibold">„{leadName}" mit Elternkonto verknüpfen</p>
          <div className="flex gap-2">
            <Input placeholder="Elternkonto suchen (Name, E-Mail)…" value={suche}
              onChange={e => setSuche(e.target.value)} onKeyDown={e => e.key === 'Enter' && suchen()} data-testid="family-search" />
            <select value={rolle} onChange={e => setRolle(e.target.value)}
              className="px-2 py-1 rounded-md border border-border bg-background text-sm">
              <option value="verwalter">Verwalter</option>
              <option value="mitverwalter">Mitverwalter</option>
            </select>
            <Button size="sm" onClick={suchen}>Suchen</Button>
          </div>
          {treffer.map(t => (
            <div key={t.id} className="flex items-center justify-between gap-2 text-sm border-t border-border/30 pt-2">
              <span>{t.name} <span className="text-xs text-muted-foreground">{t.email || t.phone || ''}</span></span>
              <Button size="sm" disabled={busy} onClick={() => verknuepfen(t)} data-testid={`link-${t.id}`}>Verknüpfen</Button>
            </div>
          ))}
          <p className="text-[11px] text-muted-foreground">
            Mehrere Kinder: im Elternprofil unter „Verwaltet“ → „Kind hinzufügen“. Eltern können Kinder auch selbst in der App anlegen.
          </p>
        </CardContent>
      </Card>
      {/* Der Knopf „Check-Up heute eingetragen“ stand bis 11.10.2026 hier (ohne Datum, ohne Rückmeldung zum Kontingent).
          Eingetragen wird jetzt in der Karte „Check-Up“ links in der Akte und unter Ernährung › Mitglied. */}
    </div>
  );
}

// ── Stammplatz-QR: Kunde wählt seinen festen Wochenkurs am eigenen Handy ──
// (Beratung oder Tresen — Code 24h gültig, an diesen Lead gebunden)
function StammplatzQrButton({ leadId }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [invite, setInvite] = useState(null);

  const generate = async (plaetze) => {
    setBusy(true);
    try {
      const res = await stammplatzAPI.createInvite(leadId, plaetze);
      setInvite(res.data);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'QR konnte nicht erstellt werden');
    } finally { setBusy(false); }
  };

  return (
    <>
      <Button size="sm" variant="outline" onClick={() => { setOpen(true); setInvite(null); }} data-testid="stammplatz-qr-btn">
        📌 Stammplatz-QR
      </Button>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4"
          onClick={() => setOpen(false)}>
          <div className="bg-background rounded-xl border shadow-xl p-6 w-full max-w-sm text-center"
            onClick={(e) => e.stopPropagation()}>
            <h3 className="font-bold">Stammplatz-Wahl per QR</h3>
            {!invite ? (
              <>
                <p className="text-sm text-muted-foreground mt-2">
                  Der Kunde scannt den Code mit dem Handy und wählt seinen festen Wochenkurs selbst —
                  der Stammplatz wird sofort aktiv. Wie viele Kurse darf er wählen?
                </p>
                <div className="flex gap-3 mt-4 justify-center">
                  <Button onClick={() => generate(1)} disabled={busy}>1 Kurs (1x/Woche)</Button>
                  <Button onClick={() => generate(2)} disabled={busy} variant="outline">2 Kurse (2x/Woche)</Button>
                </div>
              </>
            ) : (
              <>
                <p className="text-sm text-muted-foreground mt-1">
                  {invite.lead_name} · {invite.max_plaetze} {invite.max_plaetze === 1 ? 'Wahl' : 'Wahlen'} · {invite.gueltig_stunden}h gültig
                </p>
                <img src={invite.qr_code} alt="Stammplatz QR-Code" className="mx-auto mt-3 w-56 h-56 rounded-lg border" />
                <button
                  className="text-xs text-muted-foreground underline mt-2"
                  onClick={() => { navigator.clipboard?.writeText(invite.url); toast.success('Link kopiert'); }}
                >
                  Link stattdessen kopieren
                </button>
              </>
            )}
            <Button variant="outline" size="sm" className="mt-5 w-full" onClick={() => setOpen(false)}>Schließen</Button>
          </div>
        </div>
      )}
    </>
  );
}


// ── Kids-Challenge (Kids Launch Herbst 2026) ────────────────────────────────
// Zahlungslink aus dem CRM (Stripe), Zahlung kommt per Webhook zurueck, hier
// Stand, Anwesenheiten aus der App, "bestanden" am 05.12. und Erstattung.
function ChallengeBlock({ leadId, darfVerkauf }) {
  const [daten, setDaten] = useState(null);
  const [artikel, setArtikel] = useState({});
  const [track, setTrack] = useState('kids');
  const [busy, setBusy] = useState(false);
  const fmt = (v) => `${Number(v || 0).toFixed(2).replace('.', ',')} €`;
  const laden = async () => {
    try {
      const [r, a] = await Promise.all([challengeAPI.vonLead(leadId), challengeAPI.artikel()]);
      setDaten(r.data); setArtikel(a.data.artikel || {});
    } catch { setDaten({ teilnahme: null }); }
  };
  useEffect(() => { laden(); }, [leadId]); // eslint-disable-line react-hooks/exhaustive-deps
  const t = daten?.teilnahme;
  const aktion = async (fn, erfolg) => {
    setBusy(true);
    try { await fn(); toast.success(erfolg); await laden(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Aktion fehlgeschlagen.'); }
    setBusy(false);
  };
  const linkErzeugen = () => aktion(async () => {
    const r = await challengeAPI.zahlungslink(leadId, track);
    try { await navigator.clipboard.writeText(r.data.url); } catch { /* Link steht unten */ }
  }, 'Zahlungslink erzeugt und kopiert');
  const erstatten = () => {
    const eingabe = window.prompt(`Betrag erstatten (max. ${fmt(t.betrag)}) — leer = voller Betrag:`, '');
    if (eingabe === null) return;
    const betrag = eingabe.trim() === '' ? null : Number(eingabe.replace(',', '.'));
    const grund = window.prompt('Grund (optional):', '') || '';
    aktion(() => challengeAPI.erstatten(leadId, betrag, grund), 'Erstattung über Stripe ausgelöst');
  };
  if (!daten) return <p className="text-sm text-muted-foreground">Lade…</p>;
  const STATUS = { link_erzeugt: 'Link erzeugt, noch nicht bezahlt', bezahlt: 'Bezahlt' };
  return (
    <Card>
      <CardHeader><CardTitle className="text-base">Kids-Challenge Herbst 2026</CardTitle></CardHeader>
      <CardContent className="space-y-3 text-sm">
        {!t ? (
          <>
            <p className="text-muted-foreground">Noch keine Teilnahme. Zahlungslink für die Eltern erzeugen (Stripe, einmalig).</p>
            {darfVerkauf && (
              <div className="flex flex-wrap items-center gap-2">
                <select value={track} onChange={(e) => setTrack(e.target.value)} className="h-9 rounded-md border border-input bg-background px-3 text-sm" data-testid="challenge-track">
                  {Object.entries(artikel).map(([k, a]) => <option key={k} value={k}>{a.name} · {fmt(a.preis)}</option>)}
                </select>
                <Button size="sm" onClick={linkErzeugen} disabled={busy} data-testid="challenge-link">Zahlungslink erzeugen</Button>
              </div>
            )}
          </>
        ) : (
          <>
            <div className="grid sm:grid-cols-2 gap-x-6 gap-y-1">
              <div className="flex justify-between"><span className="text-muted-foreground">Artikel</span><span className="font-medium">{t.artikel_name}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Status</span><Badge variant={t.status === 'bezahlt' ? 'default' : 'outline'}>{STATUS[t.status] || t.status}</Badge></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Betrag</span><span className="font-medium">{fmt(t.betrag)}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Zahldatum</span><span className="font-medium">{t.zahldatum ? new Date(t.zahldatum).toLocaleDateString('de-DE') : '—'}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Anwesenheiten (App)</span><span className="font-medium" data-testid="challenge-anwesenheiten">{t.anwesenheiten ?? 0}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Bestanden</span><span className="font-medium">{t.bestanden === null || t.bestanden === undefined ? 'offen (05.12.)' : t.bestanden ? 'ja' : 'nein'}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Gutschrift offen</span><span className="font-medium">{fmt(t.gutschrift_offen)}{t.einstieg_entfaellt ? ` + Einstieg ${fmt(t.einstieg_entfaellt)} entfällt` : ''}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Erstattet</span><span className="font-medium">{t.erstattet ? `${fmt(t.erstattet.betrag)} am ${new Date(t.erstattet.am).toLocaleDateString('de-DE')}` : '—'}</span></div>
            </div>
            {t.status === 'link_erzeugt' && t.link && (
              <div className="text-xs break-all bg-muted/50 rounded p-2">Zahlungslink: <a className="underline" href={t.link} target="_blank" rel="noreferrer">{t.link}</a></div>
            )}
            {t.artikel?.hinweis && <p className="text-xs text-muted-foreground">{t.artikel.hinweis}. Gutschrift gilt bei Vertrag in der Abschlusswoche 30.11.–05.12.; die Gutschrift zur Rechnung wird in Lexware gebucht (nicht als Ausgabe).</p>}
            {darfVerkauf && t.status === 'bezahlt' && (
              <div className="flex flex-wrap gap-2 pt-1">
                <Button size="sm" variant="outline" disabled={busy} onClick={() => aktion(() => challengeAPI.bestanden(leadId, true), 'Als bestanden markiert')} data-testid="challenge-bestanden">Bestanden</Button>
                <Button size="sm" variant="outline" disabled={busy} onClick={() => aktion(() => challengeAPI.bestanden(leadId, false), 'Als nicht bestanden markiert')}>Nicht bestanden</Button>
                {!t.erstattet && <Button size="sm" variant="ghost" className="text-destructive" disabled={busy} onClick={erstatten} data-testid="challenge-erstatten">Erstatten (Stripe)</Button>}
              </div>
            )}
            {darfVerkauf && t.status === 'link_erzeugt' && (
              <Button size="sm" variant="outline" disabled={busy} onClick={linkErzeugen}>Neuen Link erzeugen</Button>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}
